var _defs, _path, _path2, _path3, _g, _g2, _path4, _polygon, _path5, _path6, _g3, _polygon2, _g4, _g5, _g6, _g7, _path7, _path8, _path9, _path0, _g8, _g9, _g0, _path1, _path10, _path11, _polygon3, _polygon4, _polygon5, _polygon6, _path12, _polygon7, _path13, _path14, _polygon8, _path15, _path16, _path17, _path18, _g1, _g10, _g11, _g12, _g13, _path19, _path20, _g14, _path21, _path22, _path23, _g15, _path24, _path25, _g16, _g17, _g18, _g19, _path26, _g20, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g21, _path38, _path39, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgHalloween(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 31.59 33.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#13a5ca;}.cls-3{fill:#13b1bb;}.cls-4{opacity:0.42;}.cls-5{fill:#fff;}.cls-6{fill:#39ebe5;}.cls-7{opacity:0.6;}.cls-8{fill:#1376be;}.cls-9{fill:#139dac;}.cls-10{fill:#660f54;}.cls-11{fill:#e81769;}.cls-12{fill:#ffdc4d;}.cls-13{opacity:0.44;}.cls-14{fill:#a71769;}.cls-15{opacity:0.5;}.cls-16{fill:#139f90;}.cls-17{opacity:0.4;}.cls-18{fill:#137a90;}.cls-19{fill:#490f54;}.cls-20{fill:#530f66;}.cls-21{clip-path:url(#clip-path);}.cls-22{fill:#fad631;}.cls-23{fill:#fad531;}.cls-24{fill:#fad431;}.cls-25{fill:#fbd331;}.cls-26{fill:#fbd231;}.cls-27{fill:#fbd131;}.cls-28{fill:#fbd031;}.cls-29{fill:#fbcf31;}.cls-30{fill:#fbce30;}.cls-31{fill:#fbcd30;}.cls-32{fill:#fbcc30;}.cls-33{fill:#fbcb30;}.cls-34{fill:#fbca30;}.cls-35{fill:#fbc930;}.cls-36{fill:#fbc830;}.cls-37{fill:#fbc730;}.cls-38{fill:#fbc630;}.cls-39{fill:#fbc530;}.cls-40{fill:#fbc430;}.cls-41{fill:#fbc330;}.cls-42{fill:#fcc230;}.cls-43{fill:#fcc130;}.cls-44{fill:#fcc030;}.cls-45{fill:#fcbf30;}.cls-46{fill:#fcbe30;}.cls-47{fill:#fcbd30;}.cls-48{fill:#fcbc30;}.cls-49{fill:#fcbb30;}.cls-50{fill:#fcb92f;}.cls-51{fill:#fcb82f;}.cls-52{fill:#fcb72f;}.cls-53{fill:#fcb62f;}.cls-54{fill:#fcb52f;}.cls-55{fill:#fcb42f;}.cls-56{fill:#fcb32f;}.cls-57{fill:#fcb22f;}.cls-58{fill:#fdb12f;}.cls-59{fill:#fdb02f;}.cls-60{fill:#fdaf2f;}.cls-61{fill:#fdae2f;}.cls-62{fill:#fdad2f;}.cls-63{fill:#fdac2f;}.cls-64{fill:#fdab2f;}.cls-65{fill:#fdaa2f;}.cls-66{fill:#fda92f;}.cls-67{fill:#fda82f;}.cls-68{fill:#fda72f;}.cls-69{fill:#fda62f;}.cls-70{fill:#fda52e;}.cls-71{fill:#fda42e;}.cls-72{fill:#fda32e;}.cls-73{fill:#fda22e;}.cls-74{fill:#fda12e;}.cls-75{fill:#fea02e;}.cls-76{fill:#fe9f2e;}.cls-77{fill:#fe9e2e;}.cls-78{fill:#fe9d2e;}.cls-79{fill:#fe9c2e;}.cls-80{fill:#fe9b2e;}.cls-81{fill:#fe9a2e;}.cls-82{fill:#fe992e;}.cls-83{fill:#fe982e;}.cls-84{fill:#fe972e;}.cls-85{fill:#fe962e;}.cls-86{fill:#fe952e;}.cls-87{fill:#fe942e;}.cls-88{fill:#fe932e;}.cls-89{fill:#fe922e;}.cls-90{fill:#fe912d;}.cls-91{fill:#fe902d;}.cls-92{fill:#ff8f2d;}.cls-93{fill:#ff8e2d;}.cls-94{fill:#ff8d2d;}.cls-95{fill:#ff8c2d;}.cls-96{fill:#ff8b2d;}.cls-97{fill:#ff8a2d;}.cls-98{fill:#ff892d;}.cls-99{fill:#ff882d;}.cls-100{fill:#ff872d;}.cls-101{fill:#fbc736;}.cls-102{clip-path:url(#clip-path-2);}.cls-103{fill:#f9dd31;}.cls-104{fill:#f9dc31;}.cls-105{fill:#f9db31;}.cls-106{fill:#f9da30;}.cls-107{fill:#f9d930;}.cls-108{fill:#f9d830;}.cls-109{fill:#f9d730;}.cls-110{fill:#f9d630;}.cls-111{fill:#f9d530;}.cls-112{fill:#f9d430;}.cls-113{fill:#f9d330;}.cls-114{fill:#f9d230;}.cls-115{fill:#f9d130;}.cls-116{fill:#f9d030;}.cls-117{fill:#f9cf30;}.cls-118{fill:#f9ce2f;}.cls-119{fill:#f9cd2f;}.cls-120{fill:#f9cc2f;}.cls-121{fill:#f9cb2f;}.cls-122{fill:#f9ca2f;}.cls-123{fill:#f9c92f;}.cls-124{fill:#f9c82f;}.cls-125{fill:#f9c72f;}.cls-126{fill:#f9c62f;}.cls-127{fill:#f9c52f;}.cls-128{fill:#f9c42f;}.cls-129{fill:#f9c32f;}.cls-130{fill:#f9c22f;}.cls-131{fill:#f9c12e;}.cls-132{fill:#f9c02e;}.cls-133{fill:#f9bf2e;}.cls-134{fill:#f9be2e;}.cls-135{fill:#f9bd2e;}.cls-136{fill:#f9bc2e;}.cls-137{fill:#f9bb2e;}.cls-138{fill:#f9ba2e;}.cls-139{fill:#f9b92e;}.cls-140{fill:#f9b82e;}.cls-141{fill:#f9b72e;}.cls-142{fill:#f9b62e;}.cls-143{fill:#f9b52d;}.cls-144{fill:#f9b42d;}.cls-145{fill:#f9b32d;}.cls-146{fill:#f9b22d;}.cls-147{fill:#f9b12d;}.cls-148{fill:#f9b02d;}.cls-149{fill:#f9af2d;}.cls-150{fill:#f9ae2d;}.cls-151{fill:#f9ad2d;}.cls-152{fill:#f9ac2d;}.cls-153{fill:#f9ab2d;}.cls-154{fill:#f9aa2d;}.cls-155{fill:#f9a92c;}.cls-156{fill:#f9a82c;}.cls-157{fill:#f9a72c;}.cls-158{fill:#f9a62c;}.cls-159{fill:#f9a52c;}.cls-160{fill:#f9a42c;}.cls-161{fill:#f9a32c;}.cls-162{fill:#f8a12c;}.cls-163{fill:#f8a02c;}.cls-164{fill:#f89f2c;}.cls-165{fill:#f89e2c;}.cls-166{fill:#f89d2c;}.cls-167{fill:#f89c2c;}.cls-168{fill:#f89b2b;}.cls-169{fill:#f89a2b;}.cls-170{fill:#f8992b;}.cls-171{fill:#f8982b;}.cls-172{fill:#f8972b;}.cls-173{fill:#f8962b;}.cls-174{fill:#f8952b;}.cls-175{fill:#f8942b;}.cls-176{fill:#f8932b;}.cls-177{fill:#f8922b;}.cls-178{fill:#f8912b;}.cls-179{fill:#f8902b;}.cls-180{fill:#f88f2a;}.cls-181{fill:#f88e2a;}.cls-182{fill:#f88d2a;}.cls-183{fill:#f88c2a;}.cls-184{fill:#f88b2a;}.cls-185{fill:#f88a2a;}.cls-186{fill:#f8892a;}.cls-187{fill:#f8882a;}.cls-188{fill:#f8872a;}.cls-189{fill:#f8862a;}.cls-190{fill:#f8852a;}.cls-191{fill:#f8842a;}.cls-192{fill:#f88329;}.cls-193{fill:#f88229;}.cls-194{fill:#f88129;}.cls-195{fill:#f88029;}.cls-196{fill:#f87f29;}.cls-197{fill:#f87e29;}.cls-198{fill:#f87d29;}.cls-199{fill:#f87c29;}.cls-200{fill:#f87b29;}.cls-201{fill:#f87a29;}.cls-202{fill:#f87929;}.cls-203{fill:#f87829;}.cls-204{fill:#f87729;}.cls-205{fill:#f87628;}.cls-206{fill:#f87528;}.cls-207{fill:#f87428;}.cls-208{fill:#f87328;}.cls-209{fill:#f87228;}.cls-210{fill:#f87128;}.cls-211{fill:#f87028;}.cls-212{fill:#f86f28;}.cls-213{fill:#f86e28;}.cls-214{fill:#f86d28;}.cls-215{fill:#f86c28;}.cls-216{fill:#f86b28;}.cls-217{fill:#f86a27;}.cls-218{fill:#f86927;}.cls-219{fill:#f86827;}.cls-220{fill:#f86727;}.cls-221{fill:#f86627;}.cls-222{fill:#f86527;}.cls-223{fill:#f86427;}.cls-224{fill:#f86327;}.cls-225{fill:#f86227;}.cls-226{fill:#f86127;}.cls-227{fill:#f86027;}.cls-228{fill:#f85f27;}.cls-229{fill:#f85e26;}.cls-230{fill:#f85d26;}.cls-231{fill:#f85c26;}.cls-232{fill:#f85b26;}.cls-233{fill:#f85a26;}.cls-234{fill:#f85926;}.cls-235{fill:#f85826;}.cls-236{clip-path:url(#clip-path-3);}.cls-237{clip-path:url(#clip-path-4);}.cls-238{fill:#f9e131;}.cls-239{fill:#f9e031;}.cls-240{fill:#f9df31;}.cls-241{fill:#f9de31;}.cls-242{clip-path:url(#clip-path-5);}.cls-243{fill:#f9e932;}.cls-244{fill:#f9e832;}.cls-245{fill:#f9e732;}.cls-246{fill:#f9e631;}.cls-247{fill:#f9e531;}.cls-248{fill:#f9e431;}.cls-249{fill:#f9e331;}.cls-250{fill:#f9e231;}.cls-251{fill:#d82c23;}.cls-252{fill:#f8ffa2;}.cls-253{fill:#ff753e;}.cls-254{clip-path:url(#clip-path-6);}.cls-255{fill:#fcab3e;}.cls-256{fill:#fcaa3d;}.cls-257{fill:#fca93d;}.cls-258{fill:#fca83c;}.cls-259{fill:#fca73c;}.cls-260{fill:#fca63b;}.cls-261{fill:#fca53b;}.cls-262{fill:#fca43a;}.cls-263{fill:#fca33a;}.cls-264{fill:#fca239;}.cls-265{fill:#fda139;}.cls-266{fill:#fda038;}.cls-267{fill:#fd9f38;}.cls-268{fill:#fd9e37;}.cls-269{fill:#fd9d37;}.cls-270{fill:#fd9c37;}.cls-271{fill:#fd9a36;}.cls-272{fill:#fd9936;}.cls-273{fill:#fd9835;}.cls-274{fill:#fd9735;}.cls-275{fill:#fe9634;}.cls-276{fill:#fe9534;}.cls-277{fill:#fe9433;}.cls-278{fill:#fe9333;}.cls-279{fill:#fe9232;}.cls-280{fill:#fe9132;}.cls-281{fill:#fe9031;}.cls-282{fill:#fe8f31;}.cls-283{fill:#fe8e30;}.cls-284{fill:#fe8d30;}.cls-285{fill:#ff8c2f;}.cls-286{fill:#ff8b2f;}.cls-287{fill:#ff8a2e;}.cls-288{fill:#ff892e;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-9.07 -8.15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.66,37.54h0L36,38h0l-.15.1h0a16.52,16.52,0,0,1-4,2,27.11,27.11,0,0,1-2.69.8l-.51.12-.07,0a21.69,21.69,0,0,1-7.17.4q-.53-.06-1-.15h0A16.28,16.28,0,0,1,16,39.84a13.75,13.75,0,0,1-2.59-1.64c-.18-.15-.36-.3-.53-.46A9.23,9.23,0,0,1,9.7,29.09a8.18,8.18,0,0,1,.24-.91v0h0c.1-.31.21-.61.33-.89h0c.06-.15.13-.29.19-.43h0c.11-.22.21-.43.32-.63h0a8.43,8.43,0,0,1,1.3-1.79h0a7.71,7.71,0,0,1,6.15-2.06c1.61.06,3.05.35,4,.3h.23a33,33,0,0,0,5.33-.3c1.1-.13,2.35-.31,3.78-.56l.94-.18a6.09,6.09,0,0,1,5.69,2.27c.2.23.38.46.56.71s.29.45.43.68l0,0c.13.23.25.47.37.72h0a10.16,10.16,0,0,1,.64,1.83l.06.31h0a2.21,2.21,0,0,1,0,.25c0,.25.08.5.1.75h0a.28.28,0,0,1,0,.09s0,0,0,.07A9.47,9.47,0,0,1,36.66,37.54Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-9.07 -8.15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.37,38.21c-.12-.71-.23-1.41-.29-2.12S13,34.67,13,34a17.31,17.31,0,0,1,.63-4.23,16.93,16.93,0,0,1,3-5.79c.23-.29.48-.57.73-.85l.79-.81.11.09c-.27.26-.53.53-.79.8s-.49.56-.72.85a15.82,15.82,0,0,0-1.27,1.8,16.23,16.23,0,0,0-1.73,3.94,17.14,17.14,0,0,0-.63,4.2c0,.71,0,1.41.07,2.12s.16,1.41.28,2.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-9.07 -8.15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.35,41.27c-1.06-9.51.52-15.39,2-18.65l.14,0c-1.51,3.25-3.08,9.11-2,18.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(-9.07 -8.15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.79,41l-.14,0a35.94,35.94,0,0,0-.94-18.63l.14,0a33.2,33.2,0,0,1,1.58,7.54A37.54,37.54,0,0,1,28.79,41Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(-9.07 -8.15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.11,38H36a23.92,23.92,0,0,0,.45-2.8c.06-.56.09-1.11.1-1.65a17.16,17.16,0,0,0-.2-2.9,14.61,14.61,0,0,0-1.78-5.14h0c-.07-.11-.13-.23-.21-.35a14.65,14.65,0,0,0-2.81-3.32l.1-.09a14.64,14.64,0,0,1,2.83,3.35l.22.35v0a14.79,14.79,0,0,1,1.81,5.18,17.29,17.29,0,0,1,.19,2.91c0,.54,0,1.1-.09,1.66A23.81,23.81,0,0,1,36.11,38Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(-9.07 -8.15)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.79 26.18 10.79 26.18 10.79 26.18 10.79 26.18"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "img_halloween") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.45,14.09l-.16.57-.57,2a2.53,2.53,0,0,0-.55,0l-.13,0-.19,0h0l-.2.06-.29.11-1.72-2.22Z",
    transform: "translate(-9.07 -8.15)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.06,19.54a2.08,2.08,0,0,1-.7,1.33,2.51,2.51,0,0,1-.63.4,2.84,2.84,0,0,1-.68.2,2.77,2.77,0,0,1-.76,0,2.68,2.68,0,0,1-.75-.2l-.07,0,0,0-.17-.09-.05,0,0,0-.06,0h-.05l0,0h0l0,0,0,0,0,0h0l0,0v0h0s0,0,0,0l-.07-.06-.06-.07-.06-.07a.42.42,0,0,1-.06-.08l0,0s0,0,0,0l0,0a.56.56,0,0,0,0-.08l-.05-.08h0l0-.07,0,0,0-.06,0-.07a.08.08,0,0,0,0,0,.14.14,0,0,0,0-.06,1.46,1.46,0,0,1-.05-.2v0l-.05-.21v-.05l-.05-.24a1.87,1.87,0,0,1,0-.32,1.29,1.29,0,0,1,0-.28,2.17,2.17,0,0,1,1.32-1.7l.29-.11a2.48,2.48,0,0,1,.39-.1,3.11,3.11,0,0,1,.68,0h.33l.13,0,.07,0,.13,0,.07,0,.07,0,0,0,.06,0h.09l.11.06.07,0a2.53,2.53,0,0,1,.68.62,1.5,1.5,0,0,1,.15.23v0a2.23,2.23,0,0,1,.19.51v0l.06.26h0l0,.21v0a2.54,2.54,0,0,1,0,.29A2.72,2.72,0,0,1,26.06,19.54Z",
    transform: "translate(-9.07 -8.15)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.06,19.54a2.08,2.08,0,0,1-.7,1.33,2.51,2.51,0,0,1-.63.4,2.84,2.84,0,0,1-.68.2,2.77,2.77,0,0,1-.76,0,2.68,2.68,0,0,1-.75-.2l-.07,0,0,0-.17-.09-.05,0,0,0-.06,0h-.05l0,0h0l0,0,0,0,0,0h0l0,0v0h0s0,0,0,0l-.07-.06-.06-.07-.06-.07a.42.42,0,0,1-.06-.08l0,0,0,0,0,0a.56.56,0,0,0,0-.08l-.05-.08h0l0-.07,0,0,0-.06,0-.07a.08.08,0,0,0,0,0,.14.14,0,0,0,0-.06,1.46,1.46,0,0,1-.05-.2v0l-.05-.21v-.05l-.05-.24a1.87,1.87,0,0,1,0-.32,1.29,1.29,0,0,1,0-.28,2.17,2.17,0,0,1,1.32-1.7l.29-.11a2.48,2.48,0,0,1,.39-.1,3.11,3.11,0,0,1,.68,0h.33l.13,0,.07,0,.13,0,.07,0,.07,0,0,0,.06,0h.09l.11.06.07,0a2.53,2.53,0,0,1,.68.62,1.5,1.5,0,0,1,.15.23v0a2.23,2.23,0,0,1,.19.51v0l.06.26h0l0,.21v0a2.54,2.54,0,0,1,0,.29A2.72,2.72,0,0,1,26.06,19.54Z",
    transform: "translate(-9.07 -8.15)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M21.42,19a.1.1,0,0,1-.1-.09,1.13,1.13,0,0,1,0-.26,2,2,0,0,1,1.22-1.57l.26-.1a1.53,1.53,0,0,1,.37-.08.1.1,0,0,1,.12.07.1.1,0,0,1-.09.11l-.32.08-.25.09a1.81,1.81,0,0,0-1.09,1.42,1.77,1.77,0,0,0,0,.23.11.11,0,0,1-.1.1Z",
    transform: "translate(-9.07 -8.15)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M22.2,20.74a.1.1,0,0,1-.07,0h0l-.05-.05,0,0L22,20.56l-.06-.06-.06-.07-.05-.06,0,0,0-.05a.35.35,0,0,1,0-.08.16.16,0,0,1,0-.07.21.21,0,0,1,0-.06.1.1,0,0,1,.05-.13.12.12,0,0,1,.15.05l0,0a.16.16,0,0,0,0,.07.25.25,0,0,0,0,.07l0,0v0l.05.06.06.06.05.06.05,0,0,0,.06.05a.1.1,0,0,1,0,.14A.11.11,0,0,1,22.2,20.74Z",
    transform: "translate(-9.07 -8.15)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M25.73,17.93,25.3,18,21,18.91a1.29,1.29,0,0,1,0-.28l4.18-.87.35-.08a1.5,1.5,0,0,1,.15.23Z",
    transform: "translate(-9.07 -8.15)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "16.91 10.58 16.91 10.58 16.39 10.69 12.11 11.58 12.06 11.37 12.05 11.32 16.35 10.42 16.86 10.32 16.91 10.58"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M26.06,19.54l-.75.15-3.8.8h0l0,0a.56.56,0,0,0,0-.08l-.05-.08h0l0-.07,4.05-.84.66-.14A2.72,2.72,0,0,1,26.06,19.54Z",
    transform: "translate(-9.07 -8.15)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.44,23.41,22.63,24l.16-.62.5-1.92.33,0,.24,0,.17,0h0l.13,0a2.53,2.53,0,0,0,.55-.18Z",
    transform: "translate(-9.07 -8.15)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M26.06,19.54a2.08,2.08,0,0,1-.7,1.33,2.51,2.51,0,0,1-.63.4,2.84,2.84,0,0,1-.68.2,2.77,2.77,0,0,1-.76,0,2.68,2.68,0,0,1-.75-.2l-.07,0,0,0-.17-.09-.05,0,0,0-.06,0h-.05l0,0h0l0,0,0,0,0,0h0l0,0v0h0l.08,0a2.83,2.83,0,0,0,.76.19,2.77,2.77,0,0,0,.76,0,2.55,2.55,0,0,0,.68-.2,2.41,2.41,0,0,0,.63-.4,2.13,2.13,0,0,0,.56-.78,2.47,2.47,0,0,0,.1-.29,1.75,1.75,0,0,0,0-.56,1.24,1.24,0,0,0,0-.27h0v0l-.1-.49v0a2,2,0,0,0-.08-.26,1.33,1.33,0,0,0-.11-.24,2.18,2.18,0,0,0-.46-.58h0l0,0,.11.06.07,0a2.53,2.53,0,0,1,.68.62,1.5,1.5,0,0,1,.15.23v0a2.23,2.23,0,0,1,.19.51v0l.06.26h0l0,.21v0a2.54,2.54,0,0,1,0,.29A2.72,2.72,0,0,1,26.06,19.54Z",
    transform: "translate(-9.07 -8.15)"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "13.78 8.61 13.78 8.61 13.78 8.61 13.78 8.61"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M22.3,15.37l.55,1.39-.2.06-.89-1.31Z",
    transform: "translate(-9.07 -8.15)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M23.55,14.87l-.38,1.83-.13,0-.19,0L23,14.87Z",
    transform: "translate(-9.07 -8.15)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M23.62,21.51l.24,0v1.27h-.31Z",
    transform: "translate(-9.07 -8.15)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M25.34,23.11l-.38.16L24,21.47h0l.13,0Z",
    transform: "translate(-9.07 -8.15)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M15,23.12a28.66,28.66,0,0,1,.47-7,13.23,13.23,0,0,1,2-5.06,6.47,6.47,0,0,1,4.59-2.78c3.17-.39,5.77.18,7.7,1.7,2.94,2.3,4.36,6.72,4.22,13.14h-.35c.13-6.33-1.25-10.67-4.1-12.9-1.86-1.46-4.36-2-7.42-1.62-4,.49-5.67,4.39-6.33,7.58a28.27,28.27,0,0,0-.46,6.93Z",
    transform: "translate(-9.07 -8.15)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M22.51,22.91a1.21,1.21,0,0,1-.28.21,4.31,4.31,0,0,1-1.17.45,9,9,0,0,1-1.88.22,11.27,11.27,0,0,1-1.55-.05h-.15c-.61,0-2.86-.28-1.91-2.23l.09-.18c.24-.48.49-1,.74-1.41a10.13,10.13,0,0,1,.91-1.39,3.41,3.41,0,0,1,1.07-1,1.38,1.38,0,0,1,1.22-.07C21.1,18.14,24,21.53,22.51,22.91Z",
    transform: "translate(-9.07 -8.15)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M19.18,23.79a11.27,11.27,0,0,1-1.55-.05h-.15a6.19,6.19,0,0,0-1.82-2.41c.24-.48.49-1,.74-1.41A7.88,7.88,0,0,1,19.18,23.79Z",
    transform: "translate(-9.07 -8.15)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M22.51,22.91a1.21,1.21,0,0,1-.28.21,4.31,4.31,0,0,1-1.17.45,9.07,9.07,0,0,0-3.75-5,3.41,3.41,0,0,1,1.07-1A8.44,8.44,0,0,1,22.51,22.91Z",
    transform: "translate(-9.07 -8.15)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M22.51,22.91a1.21,1.21,0,0,1-.28.21,4.31,4.31,0,0,1-1.17.45,9,9,0,0,1-1.88.22,11.27,11.27,0,0,1-1.55-.05h-.15c-.5,0-2.11-.2-2.14-1.34a4.36,4.36,0,0,0,1.28.27h.15a11.18,11.18,0,0,0,1.54,0,9.07,9.07,0,0,0,1.89-.22,4.31,4.31,0,0,0,1.17-.45,1.21,1.21,0,0,0,.28-.21c.75-.7.36-1.94-.39-3.06C22.48,20.09,23.51,22,22.51,22.91Z",
    transform: "translate(-9.07 -8.15)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 9.68,
    cy: 10.5,
    rx: 0.63,
    ry: 0.56
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M17.92,19.6a.25.25,0,1,1-.25-.22A.24.24,0,0,1,17.92,19.6Z",
    transform: "translate(-9.07 -8.15)"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M35.35,16.5v.05a1.84,1.84,0,0,1,0,.33l-.06.25-.18.56h0L35,18l-.09.28-.13.41-.09.29-.07.23a.8.8,0,0,1-.29.41h0l-.05.05a1.11,1.11,0,0,1-.31.15h0a1.15,1.15,0,0,1-.37.06l-.16,0-.1,0a1,1,0,0,1-.62-.41.71.71,0,0,1-.13-.31.77.77,0,0,1,0-.15,1.1,1.1,0,0,1,0-.18h0s0,0,0-.06l0-.18,0-.07h0l.23-.73,0-.08.22-.7,0-.13,0-.14,0-.06a.48.48,0,0,0,0-.29v0a.58.58,0,0,0-.38-.35l0,0h0l-.07,0h-.17a.66.66,0,0,0-.25.07.55.55,0,0,0-.22.18.46.46,0,0,0-.07.14v0l-.09.27-.16.52-.09.29-.1.31-.09.27h0l-.22.71-.15.48-.1.33-.1.31-.09.27,0,.15-.15.46-.22.71,0,.1-.1.31-.09.27-.14.45,0,.1-.21.67a.69.69,0,0,1-.05.13,1,1,0,0,1-.19.25,1.19,1.19,0,0,1-.23.16,1.21,1.21,0,0,1-.73.11l-.08,0a.94.94,0,0,1-.77-.87,1,1,0,0,1,0-.24l0-.11.09-.26.1-.32,0-.11.22-.7.12-.39.05-.15.09-.27.1-.32.13-.43.12-.37.19-.62h0l.08-.26.1-.31.2-.64.05-.17.22-.68v0l.09-.27.1-.32.08-.25a2,2,0,0,1,.23-.51l.05-.07A2.09,2.09,0,0,1,30.5,15c.06-.07.13-.13.19-.19a3.38,3.38,0,0,1,.71-.44,2.43,2.43,0,0,1,.38-.13,2.54,2.54,0,0,1,.78-.12,4,4,0,0,1,.49,0l.29,0,.24.07a2,2,0,0,1,.31.12,2.63,2.63,0,0,1,.93.7l0,0h0l0,0h0a2.25,2.25,0,0,1,.35.62,1.91,1.91,0,0,1,.11.41A1.56,1.56,0,0,1,35.35,16.5Z",
    transform: "translate(-9.07 -8.15)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M30,22.66l-.21.67a.69.69,0,0,1-.05.13L28,22.16l0-.11.22-.7Z",
    transform: "translate(-9.07 -8.15)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M29.56,23.71a1.19,1.19,0,0,1-.23.16l-1.51-1.13.09-.26Z",
    transform: "translate(-9.07 -8.15)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "21.55 12.57 21.33 13.28 21.3 13.38 19.55 12.07 19.69 11.64 19.8 11.26 21.55 12.57"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "21.2 13.69 21.12 13.96 19.37 12.65 19.45 12.38 21.2 13.69"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "22.18 10.57 22.04 11.04 21.93 11.38 20.18 10.07 20.38 9.43 20.44 9.26 22.18 10.57"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "21.83 11.69 21.75 11.96 20 10.65 20 10.64 20.08 10.38 21.83 11.69"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M31.91,16.62l-.16.52-.09.29-1.75-1.31.08-.25a2,2,0,0,1,.23-.51Z",
    transform: "translate(-9.07 -8.15)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "22.49 9.59 22.41 9.86 22.41 9.86 20.66 8.55 20.74 8.28 22.49 9.59"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M35.32,16.88l-.06.25-.18.56h0l-1.83-1.37a.58.58,0,0,0-.38-.35l0,0h0l-.07,0L31,14.62a2.46,2.46,0,0,1,.45-.25,2.43,2.43,0,0,1,.38-.13Z",
    transform: "translate(-9.07 -8.15)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M32.3,16a.55.55,0,0,0-.22.18L30.5,15c.06-.07.13-.13.19-.19Z",
    transform: "translate(-9.07 -8.15)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "25.91 9.86 25.82 10.13 24.07 8.82 24.11 8.7 24.16 8.55 25.91 9.86"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M34.82,15.09l-.93-.7A2.63,2.63,0,0,1,34.82,15.09Z",
    transform: "translate(-9.07 -8.15)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M35.33,16.19l-2.77-2.07a4,4,0,0,1,.49,0l2.17,1.63A1.91,1.91,0,0,1,35.33,16.19Z",
    transform: "translate(-9.07 -8.15)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M34.67,19l-.07.23a.8.8,0,0,1-.29.41h0l-.05.05-1.59-1.19h0l.23-.73,0-.08Z",
    transform: "translate(-9.07 -8.15)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M34,19.83a1.15,1.15,0,0,1-.37.06l-1-.76a.77.77,0,0,1,0-.15,1.1,1.1,0,0,1,0-.18Z",
    transform: "translate(-9.07 -8.15)"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M32.47,15.94h0a.66.66,0,0,0-.2.06.52.52,0,0,0-.21.18.47.47,0,0,0-.08.14,0,0,0,0,1,0,0l-.08.27-.17.52-.09.29-.1.31-.08.27h0l-.22.71-.15.48-.11.33-.1.31-.08.27-.05.15-.14.46-.22.71,0,.1-.1.31-.08.27-.14.45,0,.1-.21.67-.06.13a.79.79,0,0,1-.19.25.94.94,0,0,1-.23.16,1.16,1.16,0,0,1-.72.11l-.07,0a1.06,1.06,0,0,0,.43-.12.78.78,0,0,0,.24-.16,1,1,0,0,0,.24-.38l.21-.66,0-.11.14-.44.09-.27.09-.31,0-.11.22-.7.14-.46.05-.16.09-.26.09-.32.11-.33.15-.48.22-.7h0l.09-.26.1-.31.09-.29.16-.52.09-.28v0a.64.64,0,0,1,.08-.14A.62.62,0,0,1,32,16a.67.67,0,0,1,.25-.08h.27Z",
    transform: "translate(-9.07 -8.15)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M35.36,16.5v.05a1.86,1.86,0,0,1,0,.33,1,1,0,0,1-.06.25l-.17.56h0L35,18l-.08.28-.13.41-.09.29-.08.23a.84.84,0,0,1-.28.41h0l-.06.05a1.05,1.05,0,0,1-.3.15,1.13,1.13,0,0,1-.36.06h0l-.16,0h-.09l.27-.05h0a1.3,1.3,0,0,0,.31-.16l.05,0h0a1,1,0,0,0,.29-.42l.07-.23.09-.29.13-.41.08-.27.1-.32h0l.17-.56a1.05,1.05,0,0,0,.06-.24,1.27,1.27,0,0,0,0-.34v-.05c0-.1,0-.21,0-.31a1.91,1.91,0,0,0-.11-.41,2.25,2.25,0,0,0-.35-.62h0l0,0h0l0,0a2.58,2.58,0,0,0-.94-.7l-.31-.12L33,14.18l-.29-.06h0a2.31,2.31,0,0,1,.37,0l.3,0,.23.07a1.66,1.66,0,0,1,.31.12,2.54,2.54,0,0,1,.93.7l0,0h0l0,0h0a2.25,2.25,0,0,1,.35.62,1.89,1.89,0,0,1,.1.41A1.55,1.55,0,0,1,35.36,16.5Z",
    transform: "translate(-9.07 -8.15)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.05,17.33h0a.09.09,0,0,1-.07-.12l.45-1.45a.11.11,0,0,1,.14-.07.09.09,0,0,1,.07.12l-.46,1.45A.1.1,0,0,1,30.05,17.33Z",
    transform: "translate(-9.07 -8.15)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M29.44,19.27h0a.09.09,0,0,1-.07-.12l.22-.7a.12.12,0,0,1,.13-.07.1.1,0,0,1,.08.12v0l-.21.68A.11.11,0,0,1,29.44,19.27Z",
    transform: "translate(-9.07 -8.15)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M28.61,21.92h0a.09.09,0,0,1-.08-.11l.61-1.94a.12.12,0,0,1,.14-.07.09.09,0,0,1,.07.12l-.61,1.94A.11.11,0,0,1,28.61,21.92Z",
    transform: "translate(-9.07 -8.15)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M27.87,21.89,27,26.8a.21.21,0,0,1-.24.15h0a.19.19,0,0,1-.18-.21l.88-4.91.2,0Z",
    transform: "translate(-9.07 -8.15)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M30.41,20.12a1.75,1.75,0,0,1-.18.53,2.47,2.47,0,0,1-2.36,1.24l-.21,0-.2,0a2.13,2.13,0,0,1-1.81-2.36l.06-.24a2.45,2.45,0,0,1,2.69-1.51A2.15,2.15,0,0,1,30.41,20.12Z",
    transform: "translate(-9.07 -8.15)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M30.41,20.12a1.75,1.75,0,0,1-.18.53,1.33,1.33,0,0,1-.57-.35c-.7-.67-2,.91-3.18-.48a2.09,2.09,0,0,0-.77-.59,2.45,2.45,0,0,1,2.69-1.51A2.15,2.15,0,0,1,30.41,20.12Z",
    transform: "translate(-9.07 -8.15)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M30.41,20.12a1.38,1.38,0,0,1-.08.29,1,1,0,0,1-.78-.29c-.64-.57-1.73.85-2.8-.32a1.61,1.61,0,0,0-1-.58,2.44,2.44,0,0,1,2.68-1.5A2.15,2.15,0,0,1,30.41,20.12Z",
    transform: "translate(-9.07 -8.15)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M28.75,29.19a.76.76,0,0,1-.72-.57A.72.72,0,0,1,28.1,28a.58.58,0,0,1,.38-.27.75.75,0,0,1,.85.56.64.64,0,0,1-.41.83l0,0Zm-.13-1.37H28.5a.55.55,0,0,0-.34.24.65.65,0,0,0-.06.53.66.66,0,0,0,.76.51h0a.59.59,0,0,0,.36-.76A.69.69,0,0,0,28.62,27.82Z",
    transform: "translate(-9.07 -8.15)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M21.54,29.11a.48.48,0,0,1-.18,0,.38.38,0,0,1-.22-.26.46.46,0,0,1,.06-.36.55.55,0,0,1,.54-.29h0l.09,0a.38.38,0,0,1,.22.26.47.47,0,0,1-.06.36.61.61,0,0,1-.4.29Zm.14-.89a.5.5,0,0,0-.42.26.4.4,0,0,0-.05.32.32.32,0,0,0,.18.21.37.37,0,0,0,.21,0,.53.53,0,0,0,.36-.26h0a.45.45,0,0,0,.05-.32.32.32,0,0,0-.18-.21l-.08,0h-.07Z",
    transform: "translate(-9.07 -8.15)"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "31.59 13.12 10.51 13.04 31.59 13.04 31.59 13.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "31.59 13.27 0 13.15 0 13.04 10.51 13.04 31.59 13.12 31.59 13.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "31.59 13.41 0 13.29 0 13.15 31.59 13.27 31.59 13.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "31.59 13.56 0 13.44 0 13.29 31.59 13.41 31.59 13.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "31.59 13.7 0 13.59 0 13.44 31.59 13.56 31.59 13.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "31.59 13.85 0 13.73 0 13.59 31.59 13.7 31.59 13.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "31.59 13.99 0 13.88 0 13.73 31.59 13.85 31.59 13.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "31.59 14.14 0 14.02 0 13.88 31.59 13.99 31.59 14.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "31.59 14.29 0 14.17 0 14.02 31.59 14.14 31.59 14.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "31.59 14.43 0 14.31 0 14.17 31.59 14.29 31.59 14.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "31.59 14.58 0 14.46 0 14.31 31.59 14.43 31.59 14.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "31.59 14.72 0 14.6 0 14.46 31.59 14.58 31.59 14.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "31.59 14.87 0 14.75 0 14.6 31.59 14.72 31.59 14.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "31.59 15.02 0 14.89 0 14.75 31.59 14.87 31.59 15.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "31.59 15.16 0 15.04 0 14.89 31.59 15.02 31.59 15.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "31.59 15.31 0 15.19 0 15.04 31.59 15.16 31.59 15.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "31.59 15.45 0 15.33 0 15.19 31.59 15.31 31.59 15.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "31.59 15.6 0 15.48 0 15.33 31.59 15.45 31.59 15.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "31.59 15.74 0 15.62 0 15.48 31.59 15.6 31.59 15.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "31.59 15.89 0 15.77 0 15.62 31.59 15.74 31.59 15.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "31.59 16.03 0 15.91 0 15.77 31.59 15.89 31.59 16.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "31.59 16.18 0 16.06 0 15.91 31.59 16.03 31.59 16.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "31.59 16.32 0 16.21 0 16.06 31.59 16.18 31.59 16.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "31.59 16.47 0 16.35 0 16.21 31.59 16.32 31.59 16.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "31.59 16.62 0 16.5 0 16.35 31.59 16.47 31.59 16.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "31.59 16.76 0 16.64 0 16.5 31.59 16.62 31.59 16.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "31.59 16.91 0 16.79 0 16.64 31.59 16.76 31.59 16.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "31.59 17.05 0 16.93 0 16.79 31.59 16.91 31.59 17.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "31.59 17.2 0 17.08 0 16.93 31.59 17.05 31.59 17.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "31.59 17.34 0 17.23 0 17.08 31.59 17.2 31.59 17.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "31.59 17.49 0 17.37 0 17.23 31.59 17.34 31.59 17.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "31.59 17.64 0 17.52 0 17.37 31.59 17.49 31.59 17.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "31.59 17.78 0 17.66 0 17.52 31.59 17.64 31.59 17.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "31.59 17.93 0 17.81 0 17.66 31.59 17.78 31.59 17.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "31.59 18.07 0 17.95 0 17.81 31.59 17.93 31.59 18.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "31.59 18.22 0 18.1 0 17.95 31.59 18.07 31.59 18.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "31.59 18.36 0 18.24 0 18.1 31.59 18.22 31.59 18.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "31.59 18.51 0 18.39 0 18.24 31.59 18.36 31.59 18.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "31.59 18.66 0 18.54 0 18.39 31.59 18.51 31.59 18.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "31.59 18.8 0 18.68 0 18.54 31.59 18.66 31.59 18.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "31.59 18.95 0 18.83 0 18.68 31.59 18.8 31.59 18.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "31.59 19.09 0 18.97 0 18.83 31.59 18.95 31.59 19.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "31.59 19.24 0 19.12 0 18.97 31.59 19.09 31.59 19.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "31.59 19.38 0 19.26 0 19.12 31.59 19.24 31.59 19.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "31.59 19.53 0 19.41 0 19.26 31.59 19.38 31.59 19.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "31.59 19.67 0 19.55 0 19.41 31.59 19.53 31.59 19.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "31.59 19.82 0 19.7 0 19.55 31.59 19.67 31.59 19.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "31.59 19.96 0 19.85 0 19.7 31.59 19.82 31.59 19.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "31.59 20.11 0 19.99 0 19.85 31.59 19.96 31.59 20.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "31.59 20.26 0 20.14 0 19.99 31.59 20.11 31.59 20.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "31.59 20.4 0 20.28 0 20.14 31.59 20.26 31.59 20.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "31.59 20.55 0 20.43 0 20.28 31.59 20.4 31.59 20.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "31.59 20.69 0 20.57 0 20.43 31.59 20.55 31.59 20.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "31.59 20.84 0 20.72 0 20.57 31.59 20.69 31.59 20.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "31.59 20.98 0 20.86 0 20.72 31.59 20.84 31.59 20.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "31.59 21.13 0 21.01 0 20.86 31.59 20.98 31.59 21.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "31.59 21.28 0 21.16 0 21.01 31.59 21.13 31.59 21.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "31.59 21.42 0 21.3 0 21.16 31.59 21.28 31.59 21.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "31.59 21.57 0 21.45 0 21.3 31.59 21.42 31.59 21.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "31.59 21.71 0 21.59 0 21.45 31.59 21.57 31.59 21.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "31.59 21.86 0 21.74 0 21.59 31.59 21.71 31.59 21.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "31.59 22 0 21.89 0 21.74 31.59 21.86 31.59 22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "31.59 22.15 0 22.03 0 21.89 31.59 22 31.59 22.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "31.59 22.3 0 22.18 0 22.03 31.59 22.15 31.59 22.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "31.59 22.44 0 22.32 0 22.18 31.59 22.3 31.59 22.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "31.59 22.59 0 22.47 0 22.32 31.59 22.44 31.59 22.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "31.59 22.73 0 22.61 0 22.47 31.59 22.59 31.59 22.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "31.59 22.88 0 22.76 0 22.61 31.59 22.73 31.59 22.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "31.59 23.02 0 22.9 0 22.76 31.59 22.88 31.59 23.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "31.59 23.17 0 23.05 0 22.9 31.59 23.02 31.59 23.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "31.59 23.31 0 23.2 0 23.05 31.59 23.17 31.59 23.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "31.59 23.46 0 23.34 0 23.2 31.59 23.31 31.59 23.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "31.59 23.61 0 23.49 0 23.34 31.59 23.46 31.59 23.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "31.59 23.75 0 23.63 0 23.49 31.59 23.61 31.59 23.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "31.59 23.9 0 23.78 0 23.63 31.59 23.75 31.59 23.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "31.59 24.04 0 23.92 0 23.78 31.59 23.9 31.59 24.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "31.59 24.19 0 24.07 0 23.92 31.59 24.04 31.59 24.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "31.59 24.33 0 24.21 0 24.07 31.59 24.19 31.59 24.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "31.59 24.48 0 24.36 0 24.21 31.59 24.33 31.59 24.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "0 24.36 31.59 24.48 31.59 33.53 0 33.53 0 24.36"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M15.16,26.3h0C15,26.49,15,26.46,15.16,26.3Z",
    transform: "translate(-9.07 -8.15)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M28.43,24.49s0,0,0,0S28.42,24.58,28.43,24.49Z",
    transform: "translate(-9.07 -8.15)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "cls-102"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "9.23 14.23 6.29 14.13 9.23 14.13 9.23 14.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "9.23 14.34 4.29 14.17 4.29 14.13 6.29 14.13 9.23 14.23 9.23 14.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "9.23 14.44 4.29 14.27 4.29 14.17 9.23 14.34 9.23 14.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "9.23 14.54 4.28 14.38 4.29 14.27 9.23 14.44 9.23 14.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "9.23 14.65 4.28 14.48 4.28 14.38 9.23 14.54 9.23 14.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "9.23 14.75 4.28 14.58 4.28 14.48 9.23 14.65 9.23 14.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "9.23 14.85 4.27 14.69 4.28 14.58 9.23 14.75 9.23 14.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "9.23 14.96 4.27 14.79 4.27 14.69 9.23 14.85 9.23 14.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "9.23 15.06 4.26 14.89 4.27 14.79 9.23 14.96 9.23 15.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "9.23 15.16 4.26 14.99 4.26 14.89 9.23 15.06 9.23 15.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "9.23 15.27 4.25 15.1 4.26 14.99 9.23 15.16 9.23 15.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "9.23 15.37 4.25 15.2 4.25 15.1 9.23 15.27 9.23 15.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "9.23 15.47 4.24 15.3 4.25 15.2 9.23 15.37 9.23 15.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "9.23 15.58 4.24 15.41 4.24 15.3 9.23 15.47 9.23 15.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "9.23 15.68 4.24 15.51 4.24 15.41 9.23 15.58 9.23 15.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "9.23 15.79 4.23 15.62 4.24 15.51 9.23 15.68 9.23 15.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "9.23 15.89 4.23 15.72 4.23 15.62 9.23 15.79 9.23 15.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "9.23 15.99 4.22 15.82 4.23 15.72 9.23 15.89 9.23 15.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "9.23 16.09 4.22 15.93 4.22 15.82 9.23 15.99 9.23 16.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "9.23 16.2 4.21 16.03 4.22 15.93 9.23 16.09 9.23 16.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "9.23 16.3 4.21 16.13 4.21 16.03 9.23 16.2 9.23 16.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "9.23 16.41 4.2 16.23 4.21 16.13 9.23 16.3 9.23 16.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "9.23 16.51 4.2 16.34 4.2 16.23 9.23 16.41 9.23 16.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "9.23 16.61 4.19 16.44 4.2 16.34 9.23 16.51 9.23 16.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "9.23 16.72 4.19 16.55 4.19 16.44 9.23 16.61 9.23 16.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "9.23 16.82 4.18 16.65 4.19 16.55 9.23 16.72 9.23 16.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "9.23 16.92 4.18 16.75 4.18 16.65 9.23 16.82 9.23 16.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "9.23 17.03 4.18 16.86 4.18 16.75 9.23 16.92 9.23 17.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "9.23 17.13 4.17 16.96 4.18 16.86 9.23 17.03 9.23 17.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "9.23 17.23 4.17 17.06 4.17 16.96 9.23 17.13 9.23 17.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "9.23 17.34 4.16 17.17 4.17 17.06 9.23 17.23 9.23 17.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "9.23 17.44 4.16 17.27 4.16 17.17 9.23 17.34 9.23 17.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "9.23 17.52 9.23 17.55 4.15 17.37 4.16 17.27 9.23 17.44 9.23 17.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "9.23 17.55 9.22 17.65 4.15 17.48 4.15 17.37 9.23 17.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "9.22 17.65 9.22 17.75 4.14 17.58 4.15 17.48 9.22 17.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "9.22 17.75 9.21 17.86 4.14 17.68 4.14 17.58 9.22 17.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-139",
    points: "9.21 17.86 9.21 17.96 4.14 17.79 4.14 17.68 9.21 17.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "9.21 17.96 9.21 18.06 4.13 17.89 4.14 17.79 9.21 17.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "9.21 18.06 9.2 18.16 4.13 17.99 4.13 17.89 9.21 18.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "9.2 18.16 9.2 18.27 4.12 18.1 4.13 17.99 9.2 18.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "9.2 18.27 9.19 18.37 4.12 18.2 4.12 18.1 9.2 18.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-144",
    points: "9.19 18.37 9.19 18.48 4.11 18.3 4.12 18.2 9.19 18.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "9.19 18.48 9.18 18.58 4.11 18.41 4.11 18.3 9.19 18.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "9.18 18.58 9.18 18.68 4.1 18.51 4.11 18.41 9.18 18.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "9.18 18.68 9.18 18.79 4.1 18.61 4.1 18.51 9.18 18.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "9.18 18.79 9.17 18.89 4.09 18.72 4.1 18.61 9.18 18.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "9.17 18.89 9.17 18.99 4.09 18.82 4.09 18.72 9.17 18.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "9.17 18.99 9.16 19.09 4.09 18.92 4.09 18.82 9.17 18.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "9.16 19.09 9.16 19.2 4.08 19.03 4.09 18.92 9.16 19.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "9.16 19.2 9.15 19.3 4.08 19.13 4.08 19.03 9.16 19.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "9.15 19.3 9.15 19.41 4.07 19.23 4.08 19.13 9.15 19.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "9.15 19.41 9.14 19.51 4.07 19.34 4.07 19.23 9.15 19.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "9.14 19.51 9.14 19.61 4.06 19.44 4.07 19.34 9.14 19.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "9.14 19.61 9.13 19.71 4.06 19.54 4.06 19.44 9.14 19.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "9.13 19.71 9.13 19.82 4.05 19.65 4.06 19.54 9.13 19.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "9.13 19.82 9.13 19.92 4.05 19.75 4.05 19.65 9.13 19.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "9.13 19.92 9.12 20.03 4.05 19.85 4.05 19.75 9.13 19.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "9.12 20.03 9.12 20.13 4.04 19.96 4.05 19.85 9.12 20.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "9.12 20.13 9.11 20.23 4.04 20.06 4.04 19.96 9.12 20.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "9.11 20.23 9.11 20.34 4.03 20.16 4.04 20.06 9.11 20.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "9.11 20.34 9.1 20.44 4.03 20.27 4.03 20.16 9.11 20.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "9.1 20.44 9.1 20.54 4.02 20.37 4.03 20.27 9.1 20.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "9.1 20.54 9.09 20.65 4.02 20.47 4.02 20.37 9.1 20.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "9.09 20.65 9.09 20.75 4.01 20.58 4.02 20.47 9.09 20.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "9.09 20.75 9.09 20.85 4.01 20.68 4.01 20.58 9.09 20.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "9.09 20.85 9.08 20.96 4 20.78 4.01 20.68 9.09 20.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "9.08 20.96 9.08 21.06 4 20.89 4 20.78 9.08 20.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "9.08 21.06 9.07 21.16 4 20.99 4 20.89 9.08 21.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "9.07 21.16 9.07 21.27 3.99 21.09 4 20.99 9.07 21.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "9.07 21.27 9.06 21.37 3.99 21.2 3.99 21.09 9.07 21.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "9.06 21.37 9.06 21.47 3.98 21.3 3.99 21.2 9.06 21.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "9.06 21.47 9.05 21.58 3.98 21.4 3.98 21.3 9.06 21.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-175",
    points: "9.05 21.58 9.05 21.68 3.97 21.51 3.98 21.4 9.05 21.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "9.05 21.68 9.04 21.78 3.97 21.61 3.97 21.51 9.05 21.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "9.04 21.78 9.04 21.89 3.96 21.71 3.97 21.61 9.04 21.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "9.04 21.89 9.04 21.99 3.96 21.82 3.96 21.71 9.04 21.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "9.04 21.99 9.03 22.09 3.96 21.92 3.96 21.82 9.04 21.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "9.03 22.09 9.03 22.2 3.95 22.02 3.96 21.92 9.03 22.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-181",
    points: "9.03 22.2 9.02 22.3 3.95 22.13 3.95 22.02 9.03 22.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-182",
    points: "9.02 22.3 9.02 22.4 3.94 22.23 3.95 22.13 9.02 22.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-183",
    points: "9.02 22.4 9.01 22.51 3.94 22.33 3.94 22.23 9.02 22.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-184",
    points: "9.01 22.51 9.01 22.61 3.94 22.44 3.94 22.37 3.94 22.33 9.01 22.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-185",
    points: "9.01 22.61 9 22.71 3.94 22.54 3.94 22.44 9.01 22.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "9 22.71 9 22.82 3.94 22.64 3.94 22.54 9 22.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-187",
    points: "9 22.82 8.99 22.92 3.94 22.75 3.94 22.64 9 22.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-188",
    points: "8.99 22.92 8.99 23.02 3.94 22.85 3.94 22.75 8.99 22.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "8.99 23.02 8.99 23.13 3.94 22.95 3.94 22.85 8.99 23.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-190",
    points: "8.99 23.13 8.98 23.23 3.94 23.06 3.94 22.95 8.99 23.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-191",
    points: "8.98 23.23 8.98 23.33 3.94 23.16 3.94 23.06 8.98 23.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-192",
    points: "8.98 23.33 8.97 23.44 3.94 23.27 3.94 23.16 8.98 23.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "8.97 23.44 8.97 23.54 3.94 23.37 3.94 23.27 8.97 23.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "8.97 23.54 8.96 23.64 3.94 23.47 3.94 23.37 8.97 23.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "8.96 23.64 8.96 23.75 3.94 23.58 3.94 23.47 8.96 23.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "8.96 23.75 8.95 23.85 3.94 23.68 3.94 23.58 8.96 23.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-197",
    points: "8.95 23.85 8.95 23.95 3.94 23.78 3.94 23.68 8.95 23.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "8.95 23.95 8.95 24.06 3.94 23.89 3.94 23.78 8.95 23.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-199",
    points: "8.95 24.06 8.94 24.16 3.94 23.99 3.94 23.89 8.95 24.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-200",
    points: "8.94 24.16 8.94 24.26 3.94 24.09 3.94 23.99 8.94 24.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-201",
    points: "8.94 24.26 8.93 24.37 3.94 24.2 3.94 24.09 8.94 24.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-202",
    points: "8.93 24.37 8.93 24.47 3.94 24.3 3.94 24.2 8.93 24.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "8.93 24.47 8.92 24.57 3.94 24.41 3.94 24.3 8.93 24.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-204",
    points: "8.92 24.57 8.92 24.68 3.94 24.51 3.94 24.41 8.92 24.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-205",
    points: "8.92 24.68 8.91 24.78 3.94 24.61 3.94 24.51 8.92 24.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-206",
    points: "8.91 24.78 8.91 24.88 3.94 24.71 3.94 24.61 8.91 24.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-207",
    points: "8.91 24.88 8.9 24.99 3.94 24.82 3.94 24.71 8.91 24.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "8.9 24.99 8.9 25.09 3.94 24.92 3.94 24.82 8.9 24.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-209",
    points: "8.9 25.09 8.9 25.19 3.94 25.03 3.94 24.92 8.9 25.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-210",
    points: "8.9 25.19 8.89 25.3 3.94 25.13 3.94 25.03 8.9 25.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "8.89 25.3 8.89 25.4 3.94 25.23 3.94 25.13 8.89 25.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "8.89 25.4 8.88 25.5 3.94 25.34 3.94 25.23 8.89 25.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "8.88 25.5 8.88 25.61 3.94 25.44 3.94 25.34 8.88 25.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-214",
    points: "8.88 25.61 8.87 25.71 3.94 25.54 3.94 25.44 8.88 25.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "8.87 25.71 8.87 25.81 3.94 25.65 3.94 25.54 8.87 25.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-216",
    points: "8.87 25.81 8.86 25.92 3.94 25.75 3.94 25.65 8.87 25.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-217",
    points: "8.86 25.92 8.86 26.02 3.94 25.85 3.94 25.75 8.86 25.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-218",
    points: "8.86 26.02 8.86 26.12 3.94 25.96 3.94 25.85 8.86 26.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-219",
    points: "8.86 26.12 8.85 26.23 3.94 26.06 3.94 25.96 8.86 26.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "8.85 26.23 8.85 26.33 3.94 26.16 3.94 26.06 8.85 26.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "8.85 26.33 8.84 26.43 3.94 26.27 3.94 26.16 8.85 26.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "8.84 26.43 8.84 26.54 3.94 26.37 3.94 26.27 8.84 26.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "8.84 26.54 8.83 26.64 3.94 26.48 3.94 26.37 8.84 26.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "8.83 26.64 8.83 26.75 3.94 26.58 3.94 26.48 8.83 26.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-225",
    points: "8.83 26.75 8.82 26.85 3.94 26.68 3.94 26.58 8.83 26.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "8.82 26.85 8.82 26.95 3.94 26.79 3.94 26.68 8.82 26.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-227",
    points: "8.82 26.95 8.81 27.05 3.94 26.89 3.94 26.79 8.82 26.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-228",
    points: "8.81 27.05 8.81 27.16 3.94 26.99 3.94 26.89 8.81 27.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "8.81 27.16 8.81 27.26 3.94 27.1 3.94 26.99 8.81 27.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-230",
    points: "8.81 27.26 8.8 27.36 3.94 27.2 3.94 27.1 8.81 27.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "8.8 27.36 8.8 27.47 3.94 27.3 3.94 27.2 8.8 27.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "8.8 27.47 8.79 27.57 3.94 27.41 3.94 27.3 8.8 27.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-233",
    points: "8.79 27.57 8.79 27.68 3.94 27.51 3.94 27.41 8.79 27.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "8.79 27.68 8.78 27.78 3.94 27.61 3.94 27.51 8.79 27.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "8.78 27.78 8.78 27.88 3.94 27.72 3.94 27.61 8.78 27.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "8.78 27.88 8.68 30.05 3.94 30.05 3.94 27.72 8.78 27.88"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "cls-236"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "13.45 14.48 13.03 14.46 13.45 14.46 13.45 14.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "13.45 14.58 10.48 14.48 10.48 14.46 13.03 14.46 13.45 14.48 13.45 14.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "13.45 14.69 10.47 14.59 10.48 14.48 13.45 14.58 13.45 14.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "13.45 14.79 10.47 14.69 10.47 14.59 13.45 14.69 13.45 14.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "13.45 14.89 10.47 14.79 10.47 14.69 13.45 14.79 13.45 14.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "13.45 15 10.46 14.89 10.47 14.79 13.45 14.89 13.45 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "13.45 15.1 10.46 15 10.46 14.89 13.45 15 13.45 15.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "13.45 15.2 10.45 15.1 10.46 15 13.45 15.1 13.45 15.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "13.45 15.31 10.45 15.21 10.45 15.1 13.45 15.2 13.45 15.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "13.45 15.41 10.44 15.31 10.45 15.21 13.45 15.31 13.45 15.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "13.45 15.51 10.44 15.41 10.44 15.31 13.45 15.41 13.45 15.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "13.45 15.62 10.44 15.52 10.44 15.41 13.45 15.51 13.45 15.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "13.45 15.72 10.43 15.62 10.44 15.52 13.45 15.62 13.45 15.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "13.45 15.82 10.43 15.72 10.43 15.62 13.45 15.72 13.45 15.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "13.45 15.93 10.42 15.82 10.43 15.72 13.45 15.82 13.45 15.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "13.45 16.03 10.42 15.93 10.42 15.82 13.45 15.93 13.45 16.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "13.45 16.14 10.41 16.03 10.42 15.93 13.45 16.03 13.45 16.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "13.45 16.24 10.41 16.14 10.41 16.03 13.45 16.14 13.45 16.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "13.45 16.34 10.4 16.24 10.41 16.14 13.45 16.24 13.45 16.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "13.45 16.45 10.4 16.34 10.4 16.24 13.45 16.34 13.45 16.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "13.45 16.55 10.39 16.45 10.4 16.34 13.45 16.45 13.45 16.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "13.45 16.65 10.39 16.55 10.39 16.45 13.45 16.55 13.45 16.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "13.45 16.76 10.38 16.65 10.39 16.55 13.45 16.65 13.45 16.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "13.45 16.86 10.38 16.76 10.38 16.65 13.45 16.76 13.45 16.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "13.45 16.96 10.38 16.86 10.38 16.76 13.45 16.86 13.45 16.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "13.45 17.07 10.37 16.96 10.38 16.86 13.45 16.96 13.45 17.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "13.45 17.17 10.37 17.07 10.37 16.96 13.45 17.07 13.45 17.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "13.45 17.27 10.36 17.17 10.37 17.07 13.45 17.17 13.45 17.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "13.45 17.38 10.36 17.27 10.36 17.17 13.45 17.27 13.45 17.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "13.45 17.48 10.35 17.38 10.36 17.27 13.45 17.38 13.45 17.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "13.45 17.59 10.35 17.48 10.35 17.38 13.45 17.48 13.45 17.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "13.45 17.69 10.35 17.58 10.35 17.48 13.45 17.59 13.45 17.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "13.45 17.79 10.34 17.69 10.35 17.58 13.45 17.69 13.45 17.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "13.45 17.82 13.45 17.89 10.34 17.79 10.34 17.69 13.45 17.79 13.45 17.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "13.45 17.89 13.44 18 10.33 17.89 10.34 17.79 13.45 17.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-139",
    points: "13.44 18 13.44 18.1 10.33 18 10.33 17.89 13.44 18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "13.44 18.1 13.43 18.2 10.32 18.1 10.33 18 13.44 18.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "13.43 18.2 13.43 18.31 10.32 18.2 10.32 18.1 13.43 18.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "13.43 18.31 13.43 18.41 10.31 18.31 10.32 18.2 13.43 18.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "13.43 18.41 13.42 18.52 10.31 18.41 10.31 18.31 13.43 18.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-144",
    points: "13.42 18.52 13.42 18.62 10.3 18.51 10.31 18.41 13.42 18.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "13.42 18.62 13.41 18.72 10.3 18.62 10.3 18.51 13.42 18.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "13.41 18.72 13.41 18.82 10.29 18.72 10.3 18.62 13.41 18.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "13.41 18.82 13.4 18.93 10.29 18.82 10.29 18.72 13.41 18.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "13.4 18.93 13.4 19.03 10.29 18.93 10.29 18.82 13.4 18.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "13.4 19.03 13.39 19.14 10.28 19.03 10.29 18.93 13.4 19.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "13.39 19.14 13.39 19.24 10.28 19.13 10.28 19.03 13.39 19.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "13.39 19.24 13.38 19.34 10.27 19.24 10.28 19.13 13.39 19.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "13.38 19.34 13.38 19.45 10.27 19.34 10.27 19.24 13.38 19.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "13.38 19.45 13.38 19.55 10.26 19.44 10.27 19.34 13.38 19.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "13.38 19.55 13.37 19.65 10.26 19.55 10.26 19.44 13.38 19.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "13.37 19.65 13.37 19.76 10.26 19.65 10.26 19.55 13.37 19.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "13.37 19.76 13.36 19.86 10.25 19.75 10.26 19.65 13.37 19.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "13.36 19.86 13.36 19.96 10.25 19.86 10.25 19.75 13.36 19.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "13.36 19.96 13.35 20.07 10.24 19.96 10.25 19.86 13.36 19.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "13.35 20.07 13.35 20.17 10.24 20.06 10.24 19.96 13.35 20.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "13.35 20.17 13.34 20.27 10.23 20.17 10.24 20.06 13.35 20.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "13.34 20.27 13.34 20.38 10.23 20.27 10.23 20.17 13.34 20.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "13.34 20.38 13.34 20.48 10.23 20.37 10.23 20.31 10.23 20.27 13.34 20.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "13.34 20.48 13.33 20.58 10.23 20.48 10.23 20.37 13.34 20.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "13.33 20.58 13.33 20.69 10.23 20.58 10.23 20.48 13.33 20.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "13.33 20.69 13.32 20.79 10.23 20.68 10.23 20.58 13.33 20.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "13.32 20.79 13.32 20.89 10.23 20.79 10.23 20.68 13.32 20.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "13.32 20.89 13.31 21 10.23 20.89 10.23 20.79 13.32 20.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "13.31 21 13.31 21.1 10.23 21 10.23 20.89 13.31 21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "13.31 21.1 13.3 21.2 10.23 21.1 10.23 21 13.31 21.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "13.3 21.2 13.3 21.31 10.23 21.2 10.23 21.1 13.3 21.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "13.3 21.31 13.29 21.41 10.23 21.3 10.23 21.2 13.3 21.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "13.29 21.41 13.29 21.51 10.23 21.41 10.23 21.3 13.29 21.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "13.29 21.51 13.29 21.62 10.23 21.51 10.23 21.41 13.29 21.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "13.29 21.62 13.28 21.72 10.23 21.62 10.23 21.51 13.29 21.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-175",
    points: "13.28 21.72 13.28 21.82 10.23 21.72 10.23 21.62 13.28 21.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "13.28 21.82 13.27 21.93 10.23 21.82 10.23 21.72 13.28 21.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "13.27 21.93 13.27 22.03 10.23 21.93 10.23 21.82 13.27 21.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "13.27 22.03 13.26 22.13 10.23 22.03 10.23 21.93 13.27 22.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "13.26 22.13 13.26 22.24 10.23 22.13 10.23 22.03 13.26 22.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "13.26 22.24 13.25 22.34 10.23 22.24 10.23 22.13 13.26 22.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-181",
    points: "13.25 22.34 13.25 22.44 10.23 22.34 10.23 22.24 13.25 22.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-182",
    points: "13.25 22.44 13.24 22.55 10.23 22.44 10.23 22.34 13.25 22.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-183",
    points: "13.24 22.55 13.24 22.65 10.23 22.55 10.23 22.44 13.24 22.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-184",
    points: "13.24 22.65 13.24 22.75 10.23 22.65 10.23 22.55 13.24 22.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-185",
    points: "13.24 22.75 13.23 22.86 10.23 22.75 10.23 22.65 13.24 22.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "13.23 22.86 13.23 22.96 10.23 22.86 10.23 22.75 13.23 22.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-187",
    points: "13.23 22.96 13.22 23.06 10.23 22.96 10.23 22.86 13.23 22.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-188",
    points: "13.22 23.06 13.22 23.17 10.23 23.07 10.23 22.96 13.22 23.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "13.22 23.17 13.21 23.27 10.23 23.17 10.23 23.07 13.22 23.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-190",
    points: "13.21 23.27 13.21 23.37 10.23 23.27 10.23 23.17 13.21 23.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-191",
    points: "13.21 23.37 13.2 23.48 10.23 23.38 10.23 23.27 13.21 23.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-192",
    points: "13.2 23.48 13.2 23.58 10.23 23.48 10.23 23.38 13.2 23.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "13.2 23.58 13.2 23.68 10.23 23.58 10.23 23.48 13.2 23.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "13.2 23.68 13.19 23.79 10.23 23.69 10.23 23.58 13.2 23.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "13.19 23.79 13.19 23.89 10.23 23.79 10.23 23.69 13.19 23.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "13.19 23.89 13.18 23.99 10.23 23.89 10.23 23.79 13.19 23.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-197",
    points: "13.18 23.99 13.18 24.1 10.23 24 10.23 23.89 13.18 23.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "13.18 24.1 13.17 24.2 10.23 24.1 10.23 24 13.18 24.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-199",
    points: "13.17 24.2 13.17 24.3 10.23 24.2 10.23 24.1 13.17 24.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-200",
    points: "13.17 24.3 13.16 24.41 10.23 24.31 10.23 24.2 13.17 24.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-201",
    points: "13.16 24.41 13.16 24.51 10.23 24.41 10.23 24.31 13.16 24.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-202",
    points: "13.16 24.51 13.15 24.61 10.23 24.52 10.23 24.41 13.16 24.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "13.15 24.61 13.15 24.72 10.23 24.62 10.23 24.52 13.15 24.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-204",
    points: "13.15 24.72 13.15 24.82 10.23 24.72 10.23 24.62 13.15 24.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-205",
    points: "13.15 24.82 13.14 24.92 10.23 24.82 10.23 24.72 13.15 24.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-206",
    points: "13.14 24.92 13.14 25.03 10.23 24.93 10.23 24.82 13.14 24.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-207",
    points: "13.14 25.03 13.13 25.13 10.23 25.03 10.23 24.93 13.14 25.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "13.13 25.13 13.13 25.23 10.23 25.14 10.23 25.03 13.13 25.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-209",
    points: "13.13 25.23 13.12 25.34 10.23 25.24 10.23 25.14 13.13 25.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-210",
    points: "13.12 25.34 13.12 25.44 10.23 25.34 10.23 25.24 13.12 25.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "13.12 25.44 13.11 25.54 10.23 25.45 10.23 25.34 13.12 25.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "13.11 25.54 13.11 25.65 10.23 25.55 10.23 25.45 13.11 25.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "13.11 25.65 13.11 25.75 10.23 25.65 10.23 25.55 13.11 25.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-214",
    points: "13.11 25.75 13.1 25.86 10.23 25.76 10.23 25.65 13.11 25.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "13.1 25.86 13.1 25.96 10.23 25.86 10.23 25.76 13.1 25.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-216",
    points: "13.1 25.96 13.09 26.06 10.23 25.96 10.23 25.86 13.1 25.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-217",
    points: "13.09 26.06 13.09 26.16 10.23 26.07 10.23 25.96 13.09 26.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-218",
    points: "13.09 26.16 13.08 26.27 10.23 26.17 10.23 26.07 13.09 26.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-219",
    points: "13.08 26.27 13.08 26.37 10.23 26.27 10.23 26.17 13.08 26.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "13.08 26.37 13.07 26.48 10.23 26.38 10.23 26.27 13.08 26.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "13.07 26.48 13.07 26.58 10.23 26.48 10.23 26.38 13.07 26.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "13.07 26.58 13.06 26.68 10.23 26.59 10.23 26.48 13.07 26.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "13.06 26.68 13.06 26.79 10.23 26.69 10.23 26.59 13.06 26.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "13.06 26.79 13.06 26.89 10.23 26.79 10.23 26.69 13.06 26.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-225",
    points: "13.06 26.89 13.05 26.99 10.23 26.9 10.23 26.79 13.06 26.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "13.05 26.99 13.05 27.09 10.23 27 10.23 26.9 13.05 26.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-227",
    points: "13.05 27.09 13.04 27.2 10.23 27.1 10.23 27 13.05 27.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-228",
    points: "13.04 27.2 13.04 27.3 10.23 27.21 10.23 27.1 13.04 27.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "13.04 27.3 13.03 27.41 10.23 27.31 10.23 27.21 13.04 27.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-230",
    points: "13.03 27.41 13.03 27.51 10.23 27.41 10.23 27.31 13.03 27.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "13.03 27.51 13.02 27.61 10.23 27.52 10.23 27.41 13.03 27.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "13.02 27.61 13.02 27.71 10.23 27.62 10.23 27.52 13.02 27.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-233",
    points: "13.02 27.71 13.02 27.82 10.23 27.72 10.23 27.62 13.02 27.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "13.02 27.82 13.01 27.92 10.23 27.83 10.23 27.72 13.02 27.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "13.01 27.92 13.01 28.02 10.23 27.93 10.23 27.83 13.01 27.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "13.01 28.02 12.78 33.12 10.23 33.12 10.23 27.93 13.01 28.02"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "cls-237"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "21.36 14.23 19.66 14.17 21.36 14.17 21.36 14.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "21.36 14.33 18.65 14.24 18.65 14.17 19.66 14.17 21.36 14.23 21.36 14.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "21.36 14.44 18.65 14.35 18.65 14.24 21.36 14.33 21.36 14.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-241",
    points: "21.36 14.54 18.65 14.45 18.65 14.35 21.36 14.44 21.36 14.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "21.36 14.64 18.65 14.55 18.65 14.45 21.36 14.54 21.36 14.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "21.36 14.75 18.65 14.65 18.65 14.55 21.36 14.64 21.36 14.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "21.36 14.85 18.65 14.76 18.65 14.65 21.36 14.75 21.36 14.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "21.36 14.95 18.65 14.86 18.65 14.76 21.36 14.85 21.36 14.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "21.36 15.06 18.65 14.97 18.65 14.86 21.36 14.95 21.36 15.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "21.36 15.16 18.65 15.07 18.65 14.97 21.36 15.06 21.36 15.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "21.36 15.27 18.65 15.17 18.65 15.07 21.36 15.16 21.36 15.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "21.36 15.37 18.65 15.28 18.65 15.17 21.36 15.27 21.36 15.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "21.36 15.47 18.65 15.38 18.65 15.28 21.36 15.37 21.36 15.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "21.36 15.58 18.65 15.48 18.65 15.38 21.36 15.47 21.36 15.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "21.36 15.68 18.65 15.59 18.65 15.48 21.36 15.58 21.36 15.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "21.36 15.78 18.65 15.69 18.65 15.59 21.36 15.68 21.36 15.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "21.36 15.89 18.65 15.79 18.65 15.69 21.36 15.78 21.36 15.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "21.36 15.99 18.65 15.9 18.65 15.79 21.36 15.89 21.36 15.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "21.36 16.09 18.65 16 18.65 15.9 21.36 15.99 21.36 16.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "21.36 16.2 18.65 16.11 18.65 16 21.36 16.09 21.36 16.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "21.36 16.3 18.65 16.21 18.65 16.11 21.36 16.2 21.36 16.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "21.36 16.4 18.65 16.31 18.65 16.21 21.36 16.3 21.36 16.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "21.36 16.51 18.65 16.41 18.65 16.31 21.36 16.4 21.36 16.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "21.36 16.61 18.65 16.52 18.65 16.41 21.36 16.51 21.36 16.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "21.36 16.71 18.65 16.62 18.65 16.52 21.36 16.61 21.36 16.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "21.36 16.82 18.65 16.73 18.65 16.62 21.36 16.71 21.36 16.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "21.36 16.92 18.65 16.83 18.65 16.73 21.36 16.82 21.36 16.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "21.36 17.02 18.65 16.93 18.65 16.83 21.36 16.92 21.36 17.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "21.36 17.13 18.65 17.04 18.65 16.93 21.36 17.02 21.36 17.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "21.36 17.23 18.65 17.14 18.65 17.04 21.36 17.13 21.36 17.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "21.36 17.34 18.65 17.24 18.65 17.14 21.36 17.23 21.36 17.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "21.36 17.44 18.65 17.35 18.65 17.24 21.36 17.34 21.36 17.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "21.36 17.54 18.65 17.45 18.65 17.35 21.36 17.44 21.36 17.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "21.36 17.65 18.65 17.55 18.65 17.45 21.36 17.54 21.36 17.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "21.36 17.75 18.65 17.66 18.65 17.55 21.36 17.65 21.36 17.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "21.36 17.85 18.65 17.76 18.65 17.66 21.36 17.75 21.36 17.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "21.36 17.96 18.65 17.86 18.65 17.76 21.36 17.85 21.36 17.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "21.36 18.06 18.65 17.97 18.65 17.86 21.36 17.96 21.36 18.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "21.36 18.16 18.65 18.07 18.65 17.97 21.36 18.06 21.36 18.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "21.36 18.27 18.65 18.18 18.65 18.07 21.36 18.16 21.36 18.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-139",
    points: "21.36 18.37 18.65 18.28 18.65 18.18 21.36 18.27 21.36 18.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "21.36 18.47 18.65 18.38 18.65 18.28 21.36 18.37 21.36 18.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "21.36 18.58 18.65 18.49 18.65 18.38 21.36 18.47 21.36 18.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "21.36 18.68 18.65 18.59 18.65 18.49 21.36 18.58 21.36 18.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "21.36 18.79 18.65 18.69 18.65 18.59 21.36 18.68 21.36 18.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-144",
    points: "21.36 18.89 18.65 18.8 18.65 18.69 21.36 18.79 21.36 18.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "21.36 18.99 18.65 18.9 18.65 18.8 21.36 18.89 21.36 18.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "21.36 19.09 18.65 19 18.65 18.9 21.36 18.99 21.36 19.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "21.36 19.2 18.65 19.11 18.65 19 21.36 19.09 21.36 19.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "21.36 19.3 18.65 19.21 18.65 19.11 21.36 19.2 21.36 19.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "21.36 19.41 18.65 19.31 18.65 19.21 21.36 19.3 21.36 19.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "21.36 19.51 18.65 19.42 18.65 19.31 21.36 19.41 21.36 19.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "21.36 19.61 18.65 19.52 18.65 19.42 21.36 19.51 21.36 19.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "21.36 19.72 18.65 19.63 18.65 19.52 21.36 19.61 21.36 19.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "21.36 19.82 18.65 19.73 18.65 19.63 21.36 19.72 21.36 19.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "21.36 19.92 18.65 19.83 18.65 19.73 21.36 19.82 21.36 19.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "21.36 20.03 18.65 19.93 18.65 19.83 21.36 19.92 21.36 20.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "21.36 20.13 18.65 20.04 18.65 19.93 21.36 20.03 21.36 20.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "21.36 20.23 18.65 20.14 18.65 20.04 21.36 20.13 21.36 20.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "21.36 20.34 18.65 20.25 18.65 20.14 21.36 20.23 21.36 20.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "21.36 20.44 18.65 20.35 18.65 20.25 21.36 20.34 21.36 20.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "21.36 20.55 18.65 20.45 18.65 20.35 21.36 20.44 21.36 20.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "21.36 20.65 18.65 20.56 18.65 20.45 21.36 20.55 21.36 20.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "21.36 20.75 18.65 20.66 18.65 20.56 21.36 20.65 21.36 20.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "21.36 20.86 18.65 20.76 18.65 20.66 21.36 20.75 21.36 20.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "21.36 20.96 18.65 20.87 18.65 20.76 21.36 20.86 21.36 20.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "21.36 21.06 18.65 20.97 18.65 20.87 21.36 20.96 21.36 21.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "21.36 21.17 18.65 21.07 18.65 20.97 21.36 21.06 21.36 21.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "21.36 21.27 18.65 21.18 18.65 21.07 21.36 21.17 21.36 21.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "21.36 21.37 18.65 21.28 18.65 21.18 21.36 21.27 21.36 21.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "21.36 21.48 18.65 21.38 18.65 21.28 21.36 21.37 21.36 21.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "21.36 21.58 18.65 21.49 18.65 21.38 21.36 21.48 21.36 21.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "21.36 21.68 18.65 21.59 18.65 21.49 21.36 21.58 21.36 21.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "21.36 21.79 18.65 21.7 18.65 21.59 21.36 21.68 21.36 21.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "21.36 21.89 18.65 21.8 18.65 21.7 21.36 21.79 21.36 21.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "21.36 21.99 18.65 21.9 18.65 21.8 21.36 21.89 21.36 21.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-175",
    points: "21.36 22.1 18.65 22.01 18.65 21.9 21.36 21.99 21.36 22.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "21.36 22.2 18.65 22.11 18.65 22.01 21.36 22.1 21.36 22.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "21.36 22.3 18.65 22.21 18.65 22.11 21.36 22.2 21.36 22.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "21.36 22.41 18.65 22.32 18.65 22.21 21.36 22.3 21.36 22.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "21.36 22.51 18.65 22.42 18.65 22.32 21.36 22.41 21.36 22.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "21.36 22.61 18.65 22.52 18.65 22.42 21.36 22.51 21.36 22.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-181",
    points: "21.36 22.72 18.65 22.63 18.65 22.52 21.36 22.61 21.36 22.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-182",
    points: "21.36 22.82 18.65 22.73 18.65 22.63 21.36 22.72 21.36 22.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-183",
    points: "21.36 22.93 18.65 22.83 18.65 22.73 21.36 22.82 21.36 22.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-184",
    points: "21.36 23.03 18.65 22.94 18.65 22.83 21.36 22.93 21.36 23.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-185",
    points: "21.36 23.13 18.65 23.04 18.65 22.94 21.36 23.03 21.36 23.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "21.36 23.24 18.65 23.14 18.65 23.04 21.36 23.13 21.36 23.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-187",
    points: "21.36 23.34 18.65 23.25 18.65 23.14 21.36 23.24 21.36 23.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-188",
    points: "21.36 23.44 18.65 23.35 18.65 23.25 21.36 23.34 21.36 23.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "21.36 23.55 18.65 23.45 18.65 23.35 21.36 23.44 21.36 23.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-190",
    points: "21.36 23.65 18.65 23.56 18.65 23.45 21.36 23.55 21.36 23.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-191",
    points: "21.36 23.75 18.65 23.66 18.65 23.56 21.36 23.65 21.36 23.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-192",
    points: "21.36 23.86 18.65 23.77 18.65 23.66 21.36 23.75 21.36 23.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "21.36 23.96 18.65 23.87 18.65 23.77 21.36 23.86 21.36 23.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "21.36 24.06 18.65 23.97 18.65 23.87 21.36 23.96 21.36 24.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "21.36 24.17 18.65 24.08 18.65 23.97 21.36 24.06 21.36 24.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "21.36 24.27 18.65 24.18 18.65 24.08 21.36 24.17 21.36 24.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-197",
    points: "21.36 24.38 18.65 24.28 18.65 24.18 21.36 24.27 21.36 24.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "21.36 24.48 18.65 24.39 18.65 24.28 21.36 24.38 21.36 24.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-199",
    points: "21.36 24.58 18.65 24.49 18.65 24.39 21.36 24.48 21.36 24.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-200",
    points: "21.36 24.69 18.65 24.59 18.65 24.49 21.36 24.58 21.36 24.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-201",
    points: "21.36 24.79 18.65 24.7 18.65 24.59 21.36 24.69 21.36 24.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-202",
    points: "21.36 24.89 18.65 24.8 18.65 24.7 21.36 24.79 21.36 24.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "21.36 25 18.65 24.9 18.65 24.8 21.36 24.89 21.36 25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-204",
    points: "21.36 25.1 18.65 25.01 18.65 24.9 21.36 25 21.36 25.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-205",
    points: "21.36 25.2 18.65 25.11 18.65 25.01 21.36 25.1 21.36 25.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-206",
    points: "21.36 25.31 18.65 25.21 18.65 25.11 21.36 25.2 21.36 25.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-207",
    points: "21.36 25.41 18.65 25.32 18.65 25.21 21.36 25.31 21.36 25.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "21.36 25.51 18.65 25.42 18.65 25.32 21.36 25.41 21.36 25.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-209",
    points: "21.36 25.62 18.65 25.52 18.65 25.42 21.36 25.51 21.36 25.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-210",
    points: "21.36 25.72 18.65 25.63 18.65 25.52 21.36 25.62 21.36 25.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "21.36 25.82 18.65 25.73 18.65 25.63 21.36 25.72 21.36 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "21.36 25.93 18.65 25.84 18.65 25.73 21.36 25.82 21.36 25.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "21.36 26.03 18.65 25.94 18.65 25.84 21.36 25.93 21.36 26.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-214",
    points: "21.36 26.14 18.65 26.04 18.65 25.94 21.36 26.03 21.36 26.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "21.36 26.24 18.65 26.15 18.65 26.04 21.36 26.14 21.36 26.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-216",
    points: "21.36 26.34 18.65 26.25 18.65 26.15 21.36 26.24 21.36 26.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-217",
    points: "21.36 26.45 18.65 26.35 18.65 26.25 21.36 26.34 21.36 26.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-218",
    points: "21.36 26.55 18.65 26.46 18.65 26.35 21.36 26.45 21.36 26.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-219",
    points: "21.36 26.65 18.65 26.56 18.65 26.46 21.36 26.55 21.36 26.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "21.36 26.76 18.65 26.66 18.65 26.56 21.36 26.65 21.36 26.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "21.36 26.86 18.65 26.77 18.65 26.66 21.36 26.76 21.36 26.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "21.36 26.96 18.65 26.87 18.65 26.77 21.36 26.86 21.36 26.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "21.36 27.07 18.65 26.98 18.65 26.87 21.36 26.96 21.36 27.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "21.36 27.17 18.65 27.08 18.65 26.98 21.36 27.07 21.36 27.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-225",
    points: "21.36 27.27 18.65 27.18 18.65 27.08 21.36 27.17 21.36 27.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "21.36 27.38 18.65 27.29 18.65 27.18 21.36 27.27 21.36 27.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-227",
    points: "21.36 27.48 18.65 27.39 18.65 27.29 21.36 27.38 21.36 27.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-228",
    points: "21.36 27.55 21.35 27.58 18.65 27.49 18.65 27.39 21.36 27.48 21.36 27.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "21.35 27.58 21.35 27.69 18.65 27.6 18.65 27.49 21.35 27.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-230",
    points: "21.35 27.69 21.34 27.79 18.65 27.7 18.65 27.6 21.35 27.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "21.34 27.79 21.34 27.89 18.65 27.8 18.65 27.7 21.34 27.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "21.34 27.89 21.34 28 18.65 27.91 18.65 27.8 21.34 27.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-233",
    points: "21.34 28 21.33 28.1 18.65 28.01 18.65 27.91 21.34 28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "21.33 28.1 21.33 28.2 18.65 28.11 18.65 28.01 21.33 28.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "21.33 28.2 21.32 28.31 18.65 28.22 18.65 28.11 21.33 28.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "21.32 28.31 21.12 32.86 18.65 32.86 18.65 28.22 21.32 28.31"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-243",
    points: "27.61 13.61 26.57 13.58 27.61 13.58 27.61 13.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-244",
    points: "27.61 13.72 23.53 13.58 26.57 13.58 27.61 13.61 27.61 13.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-245",
    points: "27.61 13.82 22.44 13.64 22.44 13.58 23.53 13.58 27.61 13.72 27.61 13.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "27.61 13.93 22.44 13.75 22.44 13.64 27.61 13.82 27.61 13.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-247",
    points: "27.61 14.03 22.44 13.85 22.44 13.75 27.61 13.93 27.61 14.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-248",
    points: "27.61 14.13 22.44 13.96 22.44 13.85 27.61 14.03 27.61 14.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "27.61 14.23 22.44 14.06 22.44 13.96 27.61 14.13 27.61 14.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-250",
    points: "27.61 14.34 22.44 14.16 22.44 14.06 27.61 14.23 27.61 14.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "27.61 14.44 22.44 14.27 22.44 14.16 27.61 14.34 27.61 14.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "27.61 14.55 22.44 14.37 22.44 14.27 27.61 14.44 27.61 14.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "27.61 14.65 22.44 14.47 22.44 14.37 27.61 14.55 27.61 14.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-241",
    points: "27.61 14.75 22.44 14.58 22.44 14.47 27.61 14.65 27.61 14.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "27.61 14.86 22.44 14.68 22.44 14.58 27.61 14.75 27.61 14.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "27.61 14.96 22.44 14.78 22.44 14.68 27.61 14.86 27.61 14.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "27.61 15.06 22.44 14.89 22.44 14.78 27.61 14.96 27.61 15.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "27.61 15.17 22.44 14.99 22.44 14.89 27.61 15.06 27.61 15.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "27.61 15.27 22.44 15.1 22.44 14.99 27.61 15.17 27.61 15.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "27.61 15.37 22.44 15.2 22.44 15.1 27.61 15.27 27.61 15.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "27.61 15.48 22.44 15.3 22.44 15.2 27.61 15.37 27.61 15.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "27.61 15.58 22.44 15.4 22.44 15.3 27.61 15.48 27.61 15.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "27.61 15.69 22.44 15.51 22.44 15.4 27.61 15.58 27.61 15.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "27.61 15.79 22.44 15.61 22.44 15.51 27.61 15.69 27.61 15.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "27.61 15.89 22.44 15.72 22.44 15.61 27.61 15.79 27.61 15.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "27.61 15.99 22.44 15.82 22.44 15.72 27.61 15.89 27.61 15.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "27.61 16.1 22.44 15.92 22.44 15.82 27.61 15.99 27.61 16.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "27.61 16.2 22.44 16.03 22.44 15.92 27.61 16.1 27.61 16.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "27.61 16.31 22.44 16.13 22.44 16.03 27.61 16.2 27.61 16.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "27.61 16.41 22.44 16.23 22.44 16.13 27.61 16.31 27.61 16.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "27.61 16.51 22.44 16.34 22.44 16.23 27.61 16.41 27.61 16.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "27.61 16.62 22.44 16.44 22.44 16.34 27.61 16.51 27.61 16.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "27.61 16.72 22.44 16.54 22.44 16.44 27.61 16.62 27.61 16.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "27.61 16.82 22.44 16.65 22.44 16.54 27.61 16.72 27.61 16.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "27.61 16.93 22.44 16.75 22.44 16.65 27.61 16.82 27.61 16.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "27.61 17.03 22.44 16.86 22.44 16.75 27.61 16.93 27.61 17.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "27.61 17.13 22.44 16.96 22.44 16.86 27.61 17.03 27.61 17.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "27.61 17.24 22.44 17.06 22.44 16.96 27.61 17.13 27.61 17.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "27.61 17.34 22.44 17.16 22.44 17.06 27.61 17.24 27.61 17.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "27.61 17.44 22.44 17.27 22.44 17.16 27.61 17.34 27.61 17.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "27.61 17.55 22.44 17.37 22.44 17.27 27.61 17.44 27.61 17.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "27.61 17.65 22.44 17.48 22.44 17.37 27.61 17.55 27.61 17.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "27.61 17.75 22.44 17.58 22.44 17.48 27.61 17.65 27.61 17.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "27.61 17.86 22.44 17.68 22.44 17.58 27.61 17.75 27.61 17.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "27.61 17.96 22.44 17.79 22.44 17.68 27.61 17.86 27.61 17.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "27.61 18.07 22.44 17.89 22.44 17.79 27.61 17.96 27.61 18.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "27.61 18.17 22.44 17.99 22.44 17.89 27.61 18.07 27.61 18.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "27.61 18.27 22.44 18.1 22.44 17.99 27.61 18.17 27.61 18.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "27.61 18.38 22.44 18.2 22.44 18.1 27.61 18.27 27.61 18.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "27.61 18.48 22.44 18.3 22.44 18.2 27.61 18.38 27.61 18.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-139",
    points: "27.61 18.58 22.44 18.41 22.44 18.3 27.61 18.48 27.61 18.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "27.61 18.69 22.44 18.51 22.44 18.41 27.61 18.58 27.61 18.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "27.61 18.79 22.44 18.61 22.44 18.51 27.61 18.69 27.61 18.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "27.61 18.89 22.44 18.72 22.44 18.61 27.61 18.79 27.61 18.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "27.61 19 22.44 18.82 22.44 18.72 27.61 18.89 27.61 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-144",
    points: "27.61 19.1 22.44 18.93 22.44 18.82 27.61 19 27.61 19.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "27.61 19.2 22.44 19.03 22.44 18.93 27.61 19.1 27.61 19.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "27.61 19.31 22.44 19.13 22.44 19.03 27.61 19.2 27.61 19.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "27.61 19.41 22.44 19.24 22.44 19.13 27.61 19.31 27.61 19.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "27.61 19.52 22.44 19.34 22.44 19.24 27.61 19.41 27.61 19.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "27.61 19.62 22.44 19.44 22.44 19.34 27.61 19.52 27.61 19.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "27.61 19.72 22.44 19.55 22.44 19.44 27.61 19.62 27.61 19.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "27.61 19.82 22.44 19.65 22.44 19.55 27.61 19.72 27.61 19.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "27.61 19.93 22.44 19.75 22.44 19.65 27.61 19.82 27.61 19.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "27.61 20.03 22.44 19.86 22.44 19.75 27.61 19.93 27.61 20.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "27.61 20.14 22.44 19.96 22.44 19.86 27.61 20.03 27.61 20.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "27.61 20.24 22.44 20.06 22.44 19.96 27.61 20.14 27.61 20.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "27.61 20.34 22.44 20.17 22.44 20.06 27.61 20.24 27.61 20.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "27.61 20.45 22.44 20.27 22.44 20.17 27.61 20.34 27.61 20.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "27.61 20.55 22.44 20.37 22.44 20.27 27.61 20.45 27.61 20.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "27.61 20.65 22.44 20.48 22.44 20.37 27.61 20.55 27.61 20.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "27.61 20.76 22.44 20.58 22.44 20.48 27.61 20.65 27.61 20.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "27.61 20.86 22.44 20.68 22.44 20.58 27.61 20.76 27.61 20.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "27.61 20.96 22.44 20.79 22.44 20.68 27.61 20.86 27.61 20.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "27.61 21.07 22.44 20.89 22.44 20.79 27.61 20.96 27.61 21.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "27.61 21.17 22.44 21 22.44 20.89 27.61 21.07 27.61 21.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "27.61 21.27 22.44 21.1 22.44 21 27.61 21.17 27.61 21.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "27.61 21.38 22.44 21.2 22.44 21.1 27.61 21.27 27.61 21.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "27.61 21.48 22.44 21.31 22.44 21.2 27.61 21.38 27.61 21.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "27.61 21.59 22.44 21.41 22.44 21.31 27.61 21.48 27.61 21.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "27.61 21.69 22.44 21.51 22.44 21.41 27.61 21.59 27.61 21.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "27.61 21.79 22.44 21.62 22.44 21.51 27.61 21.69 27.61 21.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "27.61 21.9 22.44 21.72 22.44 21.62 27.61 21.79 27.61 21.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "27.61 22 22.44 21.82 22.44 21.72 27.61 21.9 27.61 22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "27.61 22.1 22.44 21.93 22.44 21.82 27.61 22 27.61 22.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "27.61 22.21 22.44 22.03 22.44 21.93 27.61 22.1 27.61 22.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-175",
    points: "27.61 22.31 22.44 22.13 22.44 22.03 27.61 22.21 27.61 22.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "27.61 22.41 22.44 22.24 22.44 22.13 27.61 22.31 27.61 22.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "27.61 22.52 22.44 22.34 22.44 22.24 27.61 22.41 27.61 22.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "27.61 22.62 22.44 22.45 22.44 22.34 27.61 22.52 27.61 22.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "27.61 22.72 22.44 22.55 22.44 22.45 27.61 22.62 27.61 22.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "27.61 22.83 22.44 22.65 22.44 22.55 27.61 22.72 27.61 22.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-181",
    points: "27.61 22.93 22.44 22.76 22.44 22.65 27.61 22.83 27.61 22.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-182",
    points: "27.61 23.04 22.44 22.86 22.44 22.76 27.61 22.93 27.61 23.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-183",
    points: "27.61 23.14 22.44 22.96 22.44 22.86 27.61 23.04 27.61 23.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-184",
    points: "27.61 23.24 22.44 23.07 22.44 22.96 27.61 23.14 27.61 23.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-185",
    points: "27.61 23.34 22.44 23.17 22.44 23.07 27.61 23.24 27.61 23.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "27.61 23.45 22.44 23.27 22.44 23.17 27.61 23.34 27.61 23.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-187",
    points: "27.61 23.55 22.44 23.38 22.44 23.27 27.61 23.45 27.61 23.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-188",
    points: "27.61 23.66 22.44 23.48 22.44 23.38 27.61 23.55 27.61 23.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "27.61 23.76 22.44 23.58 22.44 23.48 27.61 23.66 27.61 23.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-190",
    points: "27.61 23.86 22.44 23.69 22.44 23.58 27.61 23.76 27.61 23.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-191",
    points: "27.61 23.97 22.44 23.79 22.44 23.69 27.61 23.86 27.61 23.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-192",
    points: "27.61 24.07 22.44 23.89 22.44 23.79 27.61 23.97 27.61 24.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "27.61 24.17 22.44 24 22.44 23.89 27.61 24.07 27.61 24.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "27.61 24.28 22.44 24.1 22.44 24 27.61 24.17 27.61 24.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "27.61 24.38 22.44 24.2 22.44 24.1 27.61 24.28 27.61 24.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "27.61 24.48 22.44 24.31 22.44 24.2 27.61 24.38 27.61 24.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-197",
    points: "27.61 24.59 22.44 24.41 22.44 24.31 27.61 24.48 27.61 24.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "27.61 24.69 22.44 24.52 22.44 24.41 27.61 24.59 27.61 24.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-199",
    points: "27.61 24.8 22.44 24.62 22.44 24.52 27.61 24.69 27.61 24.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-200",
    points: "27.61 24.9 22.44 24.72 22.44 24.62 27.61 24.8 27.61 24.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-201",
    points: "27.61 25 22.44 24.83 22.44 24.72 27.61 24.9 27.61 25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-202",
    points: "27.61 25.11 22.44 24.93 22.44 24.83 27.61 25 27.61 25.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "27.61 25.21 22.44 25.03 22.44 24.93 27.61 25.11 27.61 25.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-204",
    points: "27.61 25.31 22.44 25.14 22.44 25.03 27.61 25.21 27.61 25.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-205",
    points: "27.61 25.42 22.44 25.24 22.44 25.14 27.61 25.31 27.61 25.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-206",
    points: "27.61 25.52 22.44 25.34 22.44 25.24 27.61 25.42 27.61 25.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-207",
    points: "27.61 25.62 22.44 25.45 22.44 25.34 27.61 25.52 27.61 25.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "27.61 25.73 22.44 25.55 22.44 25.45 27.61 25.62 27.61 25.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-209",
    points: "27.61 25.83 22.44 25.65 22.44 25.55 27.61 25.73 27.61 25.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-210",
    points: "27.61 25.93 22.44 25.76 22.44 25.65 27.61 25.83 27.61 25.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "27.61 26.04 22.44 25.86 22.44 25.76 27.61 25.93 27.61 26.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "27.61 26.14 22.44 25.96 22.44 25.86 27.61 26.04 27.61 26.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "27.61 26.24 22.44 26.07 22.44 25.96 27.61 26.14 27.61 26.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-214",
    points: "27.61 26.35 22.44 26.17 22.44 26.07 27.61 26.24 27.61 26.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "27.61 26.45 22.44 26.27 22.44 26.17 27.61 26.35 27.61 26.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-216",
    points: "27.61 26.55 22.44 26.38 22.44 26.27 27.61 26.45 27.61 26.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-217",
    points: "27.61 26.66 22.44 26.48 22.44 26.38 27.61 26.55 27.61 26.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-218",
    points: "27.61 26.76 22.44 26.59 22.44 26.48 27.61 26.66 27.61 26.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-219",
    points: "27.61 26.86 22.44 26.69 22.44 26.59 27.61 26.76 27.61 26.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "27.61 26.97 22.44 26.79 22.44 26.69 27.61 26.86 27.61 26.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "27.61 27.07 22.44 26.9 22.44 26.79 27.61 26.97 27.61 27.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "27.61 27.18 22.44 27 22.44 26.9 27.61 27.07 27.61 27.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "27.61 27.28 22.44 27.1 22.44 27 27.61 27.18 27.61 27.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "27.61 27.38 22.44 27.21 22.44 27.1 27.61 27.28 27.61 27.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-225",
    points: "27.61 27.49 22.44 27.31 22.44 27.21 27.61 27.38 27.61 27.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "27.61 27.59 22.44 27.41 22.44 27.31 27.61 27.49 27.61 27.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-227",
    points: "27.61 27.69 22.44 27.52 22.44 27.41 27.61 27.59 27.61 27.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-228",
    points: "27.61 27.8 22.44 27.62 22.44 27.52 27.61 27.69 27.61 27.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "27.61 27.9 22.44 27.73 22.44 27.62 27.61 27.8 27.61 27.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-230",
    points: "27.61 28 22.44 27.83 22.44 27.73 27.61 27.9 27.61 28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "27.61 28.11 22.44 27.93 22.44 27.83 27.61 28 27.61 28.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "27.61 28.21 22.44 28.04 22.44 27.93 27.61 28.11 27.61 28.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-233",
    points: "27.61 28.31 22.44 28.14 22.44 28.04 27.61 28.21 27.61 28.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "27.61 28.42 22.44 28.24 22.44 28.14 27.61 28.31 27.61 28.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "27.61 28.52 22.44 28.35 22.44 28.24 27.61 28.42 27.61 28.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "27.61 28.7 27.56 29.86 22.44 29.86 22.44 28.35 27.61 28.52 27.61 28.7"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M30.46,31.39l-.19.05a3.52,3.52,0,0,1-4-2.62,3.36,3.36,0,0,1,.34-2.73,2.73,2.73,0,0,1,1.75-1.23,3.51,3.51,0,0,1,4,2.61A3.07,3.07,0,0,1,30.46,31.39Z",
    transform: "translate(-9.07 -8.15)"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M38.75,24.59a6.59,6.59,0,0,0-4.43-2.69c-2.47-.18.28,3.58-1,1.67s-2.93-1.36-4.22-.92S29,25.49,28.29,24s-1.23-1.24-3.84-1.06a3.13,3.13,0,0,0-2.68,1.29s0-.07.07-.2c.24-.78.4-.91-1.93-1.09s-4.2,2.24-3.22,1.09.74-1.48-1.35-1.09a7.13,7.13,0,0,0-3.25,1.46,7.69,7.69,0,0,1,6.15-2.07c1.61.06,3.05.36,4,.3h.23a33.68,33.68,0,0,0,5.33-.29c1.1-.13,2.35-.32,3.78-.57l.95-.17a6.06,6.06,0,0,1,5.68,2.27A8,8,0,0,1,38.75,24.59Z",
    transform: "translate(-9.07 -8.15)"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M36.7,33.35c-1.13,2-4.29,4.36-9,5.12l-.12,0-.71.11c0-.15-.07-.31-.1-.47a3.05,3.05,0,0,0-.25-.82A17.06,17.06,0,0,0,23,37.6h0a1.52,1.52,0,0,0-.09.63c0,.2,0,.41,0,.58-3.65-.11-5.26-1.15-5.26-1.15s-2.59-1.5-2.46-3.34c0,0,0-.1,0-.15.09-.57.56-.73,1.35-.7h0c.74,0,1.77.24,3,.45,0,.07-.06.16-.09.25-.08.27-.14.56-.05.65a2.6,2.6,0,0,0,1.75.24.88.88,0,0,0,.26-.53c0-.12,0-.24,0-.35a21.12,21.12,0,0,0,4.77,0,17,17,0,0,0,1.69-.3l.09,0c.1.39.26.81.47.85a7.19,7.19,0,0,0,2.69-1c.08-.11,0-.51-.16-.89,3.11-1.34,5-3,5.85-1.89l.08.12A2.24,2.24,0,0,1,36.7,33.35Z",
    transform: "translate(-9.07 -8.15)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M21.45,34.94a.63.63,0,0,1-.22.07,1.48,1.48,0,0,0,.19-.47c0-.12,0-.24,0-.35l.26,0,0,.21A.91.91,0,0,1,21.45,34.94Z",
    transform: "translate(-9.07 -8.15)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M22.88,38.68v.14c-3.65-.11-5.26-1.15-5.26-1.15s-2.59-1.5-2.46-3.34c0,0,0-.1,0-.15a.75.75,0,0,1,.58-.64.7.7,0,0,0-.29.51.77.77,0,0,0,0,.15c-.13,1.84,2.46,3.34,2.46,3.34A10.68,10.68,0,0,0,22.88,38.68Z",
    transform: "translate(-9.07 -8.15)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M28,38.35a17.08,17.08,0,0,0,4.12-1.2,17,17,0,0,1-4.41,1.32l-.12,0-.71.11c0-.15-.07-.31-.1-.47a3.05,3.05,0,0,0-.25-.82,18.77,18.77,0,0,0-3.24.22.05.05,0,0,1,0-.05h0a17.12,17.12,0,0,1,3.49-.29A3.2,3.2,0,0,1,27,38c0,.16.07.32.1.47l.71-.1Z",
    transform: "translate(-9.07 -8.15)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M31.18,33.73c.08-.11,0-.51-.16-.89l.29-.12c.13.37.23.77.15.88a2.42,2.42,0,0,1-.74.4A1.67,1.67,0,0,0,31.18,33.73Z",
    transform: "translate(-9.07 -8.15)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M35,30.92c-.9.42-2,1.08-3.43,1.7C32.94,32,34.08,31.3,35,30.92Z",
    transform: "translate(-9.07 -8.15)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M31.31,32.71l.19-.08-.19.09Z",
    transform: "translate(-9.07 -8.15)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M30.46,31.39l-.19.05a3.52,3.52,0,0,1-4-2.62,3.36,3.36,0,0,1,.34-2.73,2.61,2.61,0,0,1,1.16-.59A3.36,3.36,0,0,1,31.58,28,3,3,0,0,1,30.46,31.39Z",
    transform: "translate(-9.07 -8.15)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M23.45,29.74a3.6,3.6,0,0,1-2.51,1.79h0a2.69,2.69,0,0,1-1.54-.17,2.63,2.63,0,0,1-1-3.84,3.49,3.49,0,0,1,3.47-1.8h0a3,3,0,0,1,.58.18A2.62,2.62,0,0,1,23.45,29.74Z",
    transform: "translate(-9.07 -8.15)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M23.77,29a2.46,2.46,0,0,0-1.28-3.11,5,5,0,0,0-.59-.18,3.69,3.69,0,0,0-2.51,1.8,2.64,2.64,0,0,0,1,3.84,2.48,2.48,0,0,0,.59.17h0a3.6,3.6,0,0,0,2.51-1.79A4.38,4.38,0,0,0,23.77,29Z",
    transform: "translate(-9.07 -8.15)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M40.32,28.4a1.58,1.58,0,0,1,0-.25A2.21,2.21,0,0,1,40.32,28.4Z",
    transform: "translate(-9.07 -8.15)"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "cls-254"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-255",
    points: "1.72 18.03 1.72 18.03 1.72 18.03 1.72 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-256",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-257",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-258",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-260",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-262",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-263",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-264",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-265",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-266",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-267",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-269",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-271",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-272",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-273",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-275",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-276",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-278",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-279",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-280",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-281",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-284",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-285",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-288",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "1.73 18.03 1.72 18.03 1.72 18.03 1.73 18.03 1.73 18.03"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 10.79,
    y: 26.18,
    transform: "translate(-9.31 -8.05) rotate(-0.54)"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M36.59,34.6Z",
    transform: "translate(-9.07 -8.15)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M36.66,37.67h0l-.62.47h0l-.15.1h0a17.29,17.29,0,0,1-4,2,27.11,27.11,0,0,1-2.69.8l-.51.12-.07,0a21.69,21.69,0,0,1-7.17.4q-.53-.06-1-.15h0A15.93,15.93,0,0,1,16,40a13.79,13.79,0,0,1-2.59-1.65c-.18-.14-.36-.3-.53-.45A9.24,9.24,0,0,1,9.7,29.23a7.64,7.64,0,0,1,.24-.91,8.08,8.08,0,0,0,.85,6c1.79,3.24,1.29-1.69,3-4.67a16.75,16.75,0,0,0,0,7.29c1,3.5,6.63,4.53,6.45,2.47,0,.18.26,1.54,2.64,2,2.55.49,5.7-.29,6.18-2.14,0,0,.44,1.36,3.94.18a5.32,5.32,0,0,0,3.59-4.7c0,.08,0,1.26.57,1.58s3.5-3.7,3.28-6.87A9.44,9.44,0,0,1,36.66,37.67Z",
    transform: "translate(-9.07 -8.15)"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M13.23,24.57a1.35,1.35,0,0,1,.46-.24.58.58,0,0,1,.5.08.38.38,0,0,1,.16.25,1.14,1.14,0,0,1-.23.87,8.11,8.11,0,0,1-.83,1.12.88.88,0,0,1-.77.39.55.55,0,0,1-.41-.42C11.94,25.88,12.64,25,13.23,24.57Z",
    transform: "translate(-9.07 -8.15)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M11.44,27.85a.52.52,0,0,1,.29-.34.09.09,0,0,1,.07,0,.05.05,0,0,1,0,0,.62.62,0,0,1,.18.53.68.68,0,0,1-.37.46C11.2,28.74,11.38,28,11.44,27.85Z",
    transform: "translate(-9.07 -8.15)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M16,31.5a.39.39,0,0,0,.21-.19c.17-.3-.08-1-.54-.68C15.37,30.85,15.51,31.66,16,31.5Z",
    transform: "translate(-9.07 -8.15)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M19.9,23.91a.94.94,0,0,0-.28,1.1.35.35,0,0,0,.11.13.31.31,0,0,0,.25,0A.91.91,0,0,0,20.65,24a.44.44,0,0,0-.16-.17.46.46,0,0,0-.44,0A.49.49,0,0,0,19.9,23.91Z",
    transform: "translate(-9.07 -8.15)"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M32.5,24.93a.88.88,0,0,0,.28.06.48.48,0,0,0,.45-.45.87.87,0,0,0-.28-.6,2.18,2.18,0,0,0-.88-.56c-.64-.21-.91.13-.65.62A2.07,2.07,0,0,0,32.5,24.93Z",
    transform: "translate(-9.07 -8.15)"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M34.16,27.16a.2.2,0,0,0,.1.12.18.18,0,0,0,.17-.06.43.43,0,0,0,.11-.41c0-.15-.35-.65-.55-.43S34.09,27,34.16,27.16Z",
    transform: "translate(-9.07 -8.15)"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M38,26.25a2.56,2.56,0,0,0,.29,1,1.79,1.79,0,0,0,.34.56.74.74,0,0,0,.47.2.42.42,0,0,0,.42-.23.48.48,0,0,0,0-.29,2.55,2.55,0,0,0-.48-1.29C38.72,25.84,38,25.52,38,26.25Z",
    transform: "translate(-9.07 -8.15)"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M37,24.25a.21.21,0,0,0-.05.23.62.62,0,0,0,.17.28.47.47,0,0,0,.27.12.19.19,0,0,0,.21-.17C37.59,24.53,37.26,24,37,24.25Z",
    transform: "translate(-9.07 -8.15)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHalloween);
export default __webpack_public_path__ + "static/media/img_halloween.f8994b6c04b4ad2912cb9ea064cb2b41.svg";
export { ForwardRef as ReactComponent };